/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AccountHold = {
  __typename?: 'AccountHold';
  invoiceIds: Array<Maybe<Scalars['String']>>;
  isOnHold: Scalars['Boolean'];
};

export enum AccountType {
  CultXTradeAccount = 'CultXTradeAccount',
  Whale = 'Whale'
}

export type ActiveMarket = {
  __typename?: 'ActiveMarket';
  assetId: Scalars['Int'];
  availableQuantity: Scalars['Int'];
  bottlePrice?: Maybe<Scalars['Float']>;
  cultxScore?: Maybe<Scalars['Float']>;
  fairValueScore?: Maybe<Scalars['Float']>;
  highestBid: ActiveMarketOrder;
  imageFileName?: Maybe<Scalars['String']>;
  isCommunity?: Maybe<Scalars['Boolean']>;
  lastTradeDateTime?: Maybe<Scalars['String']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  lowestOffer: ActiveMarketOrder;
  lwin18: Scalars['String'];
  marketValue: Scalars['Float'];
  producer?: Maybe<Scalars['String']>;
  productUrn?: Maybe<Scalars['String']>;
  region: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  spread?: Maybe<Scalars['Float']>;
  tradesLastMonth?: Maybe<Scalars['Float']>;
  unitCount: Scalars['Int'];
  unitSize: Scalars['String'];
  vinousScore?: Maybe<Scalars['Float']>;
  vintage: Scalars['Int'];
  waScore?: Maybe<Scalars['Float']>;
  wineName: Scalars['String'];
  wineUnitSize?: Maybe<Scalars['Int']>;
};

export type ActiveMarketFilters = {
  bidsAndOffers?: InputMaybe<Scalars['String']>;
  bottlePrice?: InputMaybe<Scalars['String']>;
  casePrice?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  isCommunityHoldings?: InputMaybe<Scalars['String']>;
  performance?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  producer?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitSize?: InputMaybe<Scalars['String']>;
  vintage?: InputMaybe<Scalars['String']>;
};

export type ActiveMarketFiltersResult = {
  __typename?: 'ActiveMarketFiltersResult';
  price?: Maybe<Array<Maybe<Scalars['String']>>>;
  producer?: Maybe<Array<Maybe<Scalars['String']>>>;
  region?: Maybe<Array<Maybe<Scalars['String']>>>;
  score?: Maybe<Array<Maybe<Scalars['String']>>>;
  unitCount?: Maybe<Array<Maybe<Scalars['String']>>>;
  unitSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  vintage?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ActiveMarketOrder = {
  __typename?: 'ActiveMarketOrder';
  createdDate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type ActiveMarketResult = {
  __typename?: 'ActiveMarketResult';
  results: Array<ActiveMarket>;
  total: Scalars['Int'];
};

export type AddExternalPortfolioBatchResponse = {
  __typename?: 'AddExternalPortfolioBatchResponse';
  assetId: Scalars['Int'];
  purchaseDate?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
};

export type AddExternalPortfolioInput = {
  assetId: Scalars['Int'];
  purchaseDate?: InputMaybe<Scalars['String']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  quantity: Scalars['Int'];
};

export type AddPaymentDetailInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  bicOrSwift?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  nameOnAccount?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
};

export type AddToWatchListResponse = {
  __typename?: 'AddToWatchListResponse';
  assetId: Scalars['Int'];
  watchlistItemId: Scalars['Int'];
};

export type AddWatchListGroupInput = {
  assetIds: Array<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupName?: InputMaybe<Scalars['String']>;
};

export type AddWatchListGroupResult = {
  __typename?: 'AddWatchListGroupResult';
  assetId: Scalars['Int'];
  groupId: Scalars['Int'];
  groupName: Scalars['String'];
  watchlistItemId: Scalars['Int'];
};

export type Address = {
  __typename?: 'Address';
  addressId: Scalars['ID'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  county?: Maybe<Scalars['String']>;
  createdDateTime: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  postcode: Scalars['String'];
  regionId?: Maybe<Scalars['String']>;
  town: Scalars['String'];
  type: Scalars['String'];
  updatedDateTime?: Maybe<Scalars['String']>;
};

export type AddressDeletedResult = {
  __typename?: 'AddressDeletedResult';
  deletedAddressId: Scalars['ID'];
};

export type AddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  county?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  postcode: Scalars['String'];
  regionId?: InputMaybe<Scalars['String']>;
  town: Scalars['String'];
  type: Scalars['String'];
};

export type Appellation = {
  __typename?: 'Appellation';
  appellationAuthority?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  parentAppellationId?: Maybe<Scalars['Int']>;
  regionId?: Maybe<Scalars['Int']>;
};

export type Asset = {
  __typename?: 'Asset';
  calculatedMarketData?: Maybe<CalculatedMarketData>;
  id: Scalars['Int'];
  isInWatchList: Scalars['Boolean'];
  lwin11?: Maybe<Scalars['String']>;
  lwin18?: Maybe<Scalars['String']>;
  marketData: MarketData;
  marketValue?: Maybe<Scalars['Float']>;
  openOrders: Array<BookedOrder>;
  productUrn?: Maybe<Scalars['String']>;
  provenance?: Maybe<Scalars['String']>;
  recentWineSearcherOffer: OffersResponse;
  releasePrice?: Maybe<Scalars['Float']>;
  spread?: Maybe<OrderSpread>;
  tradingInfo: TradingInfo;
  unitCount: Scalars['Int'];
  unitSize: Scalars['String'];
  unitSizeId?: Maybe<Scalars['Int']>;
  unitVolume?: Maybe<Scalars['Int']>;
  vintage: WineVintage;
  vintages: Array<WineVintage>;
  wineId?: Maybe<Scalars['Int']>;
  wineVintagesId: Scalars['Int'];
};


export type AssetMarketDataArgs = {
  currency?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};


export type AssetSpreadArgs = {
  selectLowestOffer?: InputMaybe<Scalars['Boolean']>;
};

export type AssetFeeConfig = {
  __typename?: 'AssetFeeConfig';
  hasMinTransactionFeeRate: Scalars['Boolean'];
  minTransactionFeeRate: Scalars['Float'];
  transactionFeeRate: Scalars['Float'];
  vatFeeRate: Scalars['Float'];
};

export type AssetInstance = {
  __typename?: 'AssetInstance';
  assetId: Scalars['Int'];
  bondedStatus: Scalars['String'];
  entryDate: Scalars['String'];
  id: Scalars['String'];
  inventoryType?: Maybe<Scalars['String']>;
  linkedToPhysical?: Maybe<Scalars['Boolean']>;
  location: Scalars['String'];
  monthlyCost?: Maybe<Scalars['Float']>;
  nextCharge?: Maybe<Scalars['Float']>;
  nextChargeDate?: Maybe<Scalars['String']>;
  numberOfBottle?: Maybe<Scalars['Int']>;
  purchasePrice: Scalars['Float'];
  stockStatus?: Maybe<Scalars['String']>;
  storageState?: Maybe<Scalars['String']>;
  storageStatus?: Maybe<Scalars['String']>;
  traceability: Scalars['String'];
  transferRequested?: Maybe<Scalars['Boolean']>;
  valuation?: Maybe<Scalars['Float']>;
};

export type AssetLastPurchaseResponse = {
  __typename?: 'AssetLastPurchaseResponse';
  avgPurchasePrice?: Maybe<Scalars['Float']>;
  lastPurchaseDate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type AuthChangePasswordInput = {
  clientId: Scalars['String'];
  passwordConfirm: Scalars['String'];
  passwordCurrent: Scalars['String'];
  passwordNew: Scalars['String'];
};

export type AuthChangePasswordResponse = {
  __typename?: 'AuthChangePasswordResponse';
  wasPasswordChanged: Scalars['Boolean'];
};

export type AuthCnLoginRequestInput = {
  clientId?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AuthCnRegisterUserInput = {
  emailAddress?: InputMaybe<Scalars['String']>;
  hasAgreedToMarketing?: InputMaybe<Scalars['Boolean']>;
  hasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  registeredByApp: RegisteredByApp;
  registrationType: RegistrationType;
};

export type AuthCnUser = {
  __typename?: 'AuthCnUser';
  accountType?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  isPhoneNumberVerified: Scalars['Boolean'];
  phoneNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type AuthCreateBiometricRequestInput = {
  biometricPublicKey: Scalars['String'];
};

export type AuthCreateBiometricResponse = {
  __typename?: 'AuthCreateBiometricResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess: Scalars['Boolean'];
};

export type AuthGetMfaAuthenticatorsRequestInput = {
  mfaToken: Scalars['String'];
};

export type AuthGetMfaAuthenticatorsResponse = {
  __typename?: 'AuthGetMfaAuthenticatorsResponse';
  mfaAuthenticators: Array<AuthMfaAuthenticator>;
};

export type AuthLoginRequestInput = {
  clientId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  loginByApp?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  platform?: InputMaybe<Scalars['String']>;
};

export type AuthLoginResponse = {
  __typename?: 'AuthLoginResponse';
  accessToken?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  errorDescription?: Maybe<Scalars['String']>;
  idToken?: Maybe<Scalars['String']>;
  mfaToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  userToken?: Maybe<Scalars['String']>;
};

export type AuthLoginWithBiometricRequestInput = {
  biometricPublicKey: Scalars['String'];
  clientId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

export type AuthMfaAuthenticator = {
  __typename?: 'AuthMfaAuthenticator';
  active: Scalars['Boolean'];
  authenticatorType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  oobChannel: Scalars['String'];
};

export type AuthMfaChallengeRequestInput = {
  authenticatorId: Scalars['String'];
  clientId: Scalars['String'];
  mfaToken: Scalars['String'];
};

export type AuthMfaChallengeResponse = {
  __typename?: 'AuthMfaChallengeResponse';
  challengeType: Scalars['String'];
  oobCode: Scalars['String'];
};

export type AuthMfaOobCodeVerifyRequestInput = {
  biometricPublicKey?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  mfaOobCode: Scalars['String'];
  mfaOtpCode: Scalars['String'];
  mfaToken: Scalars['String'];
  platform?: InputMaybe<Scalars['String']>;
};

export type AuthMfaOobCodeVerifyResponse = {
  __typename?: 'AuthMfaOobCodeVerifyResponse';
  accessToken: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  errorDescription?: Maybe<Scalars['String']>;
  idToken: Scalars['String'];
  refreshToken: Scalars['String'];
  scope: Scalars['String'];
  tokenType: Scalars['String'];
  userToken: Scalars['String'];
};

export type AuthRefreshAccessTokenRequestInput = {
  clientId: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type AuthRefreshAccessTokenResponse = {
  __typename?: 'AuthRefreshAccessTokenResponse';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  userToken: Scalars['String'];
};

export type AuthRegisterUserInput = {
  accountType?: InputMaybe<AccountType>;
  clientId?: InputMaybe<Scalars['String']>;
  dateOfBirth: Scalars['String'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  hasAgreedToMarketing?: InputMaybe<Scalars['Boolean']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  /** Must be one of "Zellar" or "WebsiteOnboarding" */
  registeredByApp: Scalars['String'];
  residenceCountry?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
};

export type AuthResendVerificationEmailInput = {
  application?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  emailAddress: Scalars['String'];
};

export type AuthResendVerificationEmailResponse = {
  __typename?: 'AuthResendVerificationEmailResponse';
  wasVerificationEmailResent: Scalars['Boolean'];
};

export type AuthResetPasswordInput = {
  clientId: Scalars['String'];
  emailAddress: Scalars['String'];
};

export type AuthResetPasswordResponse = {
  __typename?: 'AuthResetPasswordResponse';
  emailAddress: Scalars['String'];
};

export type AuthUpdateUserDtoInput = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  surname: Scalars['String'];
};

export type AuthUser = {
  __typename?: 'AuthUser';
  accountType?: Maybe<Scalars['String']>;
  cultWineId?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  isPhoneNumberVerified: Scalars['Boolean'];
  kycStatus?: Maybe<KycStatus>;
  mitConsentedFlag?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type AuthUserJwtResponse = {
  __typename?: 'AuthUserJwtResponse';
  /** JWT containing representation of the UserDto */
  userToken?: Maybe<Scalars['String']>;
};

export type BankDetails = {
  __typename?: 'BankDetails';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  bicOrSwift?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
};

export type BankTransferConfirmResponse = {
  __typename?: 'BankTransferConfirmResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type BankTransferPreferenceInput = {
  accNumber: Scalars['String'];
  amount: Scalars['Float'];
  bankAddress: Scalars['String'];
  bankInstitution: Scalars['String'];
  bankName: Scalars['String'];
  bic: Scalars['String'];
  company: Scalars['String'];
  currency: Scalars['String'];
  fxRate: Scalars['Float'];
  gbpAmount: Scalars['Float'];
  iban: Scalars['String'];
  reference: Scalars['String'];
  routing: Scalars['String'];
  sortCode: Scalars['String'];
};

export type BaseResponse = {
  __typename?: 'BaseResponse';
  isSuccess: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type Bid = {
  __typename?: 'Bid';
  assetId: Scalars['Int'];
  buyerCost?: Maybe<Scalars['Float']>;
  clientOrderId: Scalars['String'];
  direction: Scalars['Int'];
  filledTime: Scalars['String'];
  filledType: TaskStateEnumType;
  id: Scalars['String'];
  price: Scalars['Int'];
  purchasePrice?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  submittedTimeUtc: Scalars['String'];
  transactionFee?: Maybe<Scalars['Float']>;
  transactionFeePercent?: Maybe<Scalars['Float']>;
  userId: Scalars['String'];
};

export type BidOfferModel = {
  __typename?: 'BidOfferModel';
  clientOrderId?: Maybe<Scalars['String']>;
  direction: Scalars['String'];
  filledTime?: Maybe<Scalars['String']>;
  filledType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  quantityOutstanding: Scalars['Int'];
  userId: Scalars['String'];
};

export type BidsResult = {
  __typename?: 'BidsResult';
  appellation?: Maybe<Scalars['String']>;
  assetId: Scalars['Int'];
  bidStatus: Scalars['String'];
  calculatedMarketData: CalculatedMarketData;
  date: Scalars['String'];
  docId: Scalars['String'];
  expiryDate: Scalars['String'];
  myBid: Scalars['Float'];
  region: Scalars['String'];
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int'];
  unitSize: Scalars['String'];
  vintage: Scalars['Int'];
  wineName: Scalars['String'];
};

export type BookedOrder = {
  __typename?: 'BookedOrder';
  asset: Asset;
  assetId: Scalars['Int'];
  cancelled: Scalars['Boolean'];
  clientOrderId: Scalars['String'];
  direction: Scalars['Int'];
  executableWindow: ExecutableWindow;
  id: Scalars['ID'];
  isEpStock?: Maybe<Scalars['Boolean']>;
  isSuspended?: Maybe<Scalars['Boolean']>;
  outstandingQuantity: Scalars['Int'];
  price: Scalars['Float'];
  purchasePrice?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  status: Scalars['String'];
  submittedTimeUtc: Scalars['String'];
  suspensionReason?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type BusinessAccountInput = {
  companyName?: InputMaybe<Scalars['String']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  countryOfRegistration?: InputMaybe<Scalars['String']>;
  creditAccountAgreement?: InputMaybe<Scalars['Boolean']>;
  openCreditAccount?: InputMaybe<Scalars['Boolean']>;
  taxIdentificationNumber?: InputMaybe<Scalars['String']>;
};

export type BusinessAccountResponse = {
  __typename?: 'BusinessAccountResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<BusinessAccountResult>;
  status?: Maybe<Scalars['String']>;
};

export type BusinessAccountResult = {
  __typename?: 'BusinessAccountResult';
  companyName?: Maybe<Scalars['String']>;
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  creditAccountAgreement?: Maybe<Scalars['Boolean']>;
  openCreditAccount?: Maybe<Scalars['Boolean']>;
  taxIdentificationNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type BuyItNowInitiatedInput = {
  assetId: Scalars['Int'];
  assetUnitIds?: InputMaybe<Array<Scalars['String']>>;
  bestContactNumber?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
  deliveryInstructions?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Array<FeeItems>>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  totalPrice: Scalars['Float'];
};

export type BuyItNowInitiatedResponse = {
  __typename?: 'BuyItNowInitiatedResponse';
  clientOrderId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  initiated: Scalars['Boolean'];
};

/**
 * Photo state shown beneath the Buy Now price on the product page right rail.
 * Describes the cheapest offer and any cheapest-with-photos alternative.
 */
export type BuyNowPhotoSummary = {
  __typename?: 'BuyNowPhotoSummary';
  /** Lowest price (in display currency) of any offer that has lot photos, when the cheapest offer itself has none. Null otherwise. */
  alternativeMinPrice?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  lotDetail?: Maybe<LotDetail>;
  photos?: Maybe<Array<LotPhoto>>;
  state: LotPhotoState;
};

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type CalculatedMarketData = {
  __typename?: 'CalculatedMarketData';
  combinedScore?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  liquidityScore?: Maybe<Scalars['Float']>;
  lwin11?: Maybe<Scalars['String']>;
  lwin18?: Maybe<Scalars['String']>;
  performance: HoldingPerformanceResponse;
};

export type CancelPausedBidsInput = {
  orderIds: Array<Scalars['String']>;
};

export type CancelPausedBidsResponse = {
  __typename?: 'CancelPausedBidsResponse';
  orderIds: Array<Scalars['String']>;
};

export type CancelSettlementRequestsInput = {
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};

export type CancelSettlementRequestsResponse = {
  __typename?: 'CancelSettlementRequestsResponse';
  cancelledAt?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  invoiceIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  message?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  settlementRequestId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CancelStripeRecurringPaymentResponse = {
  __typename?: 'CancelStripeRecurringPaymentResponse';
  hasCancelled: Scalars['Boolean'];
  subscriptionId: Scalars['String'];
};

export type CancelledBidsResponse = {
  __typename?: 'CancelledBidsResponse';
  assetId: Scalars['Int'];
  cancellationStatus: Scalars['String'];
  caseSize: Scalars['String'];
  deactivatedAt: Scalars['String'];
  lwin18: Scalars['String'];
  orderId: Scalars['String'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  vintage?: Maybe<Scalars['Int']>;
  wineName: Scalars['String'];
};

export type CardDetailDeletedResult = {
  __typename?: 'CardDetailDeletedResult';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type CardDetailResponse = {
  __typename?: 'CardDetailResponse';
  clientName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  defaultMitFlag?: Maybe<Scalars['Boolean']>;
  expiry?: Maybe<Scalars['String']>;
  instrumentId?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  mitConsentedFlag?: Maybe<Scalars['Boolean']>;
  postcode?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
};

export type CardPaymentInput = {
  amount: Scalars['Float'];
  cardToken?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  defaultMitFlag?: InputMaybe<Scalars['Boolean']>;
  failureUrl: Scalars['String'];
  instrumentId?: InputMaybe<Scalars['String']>;
  mitConsentedFlag?: InputMaybe<Scalars['Boolean']>;
  operationType?: InputMaybe<Scalars['String']>;
  portfolioId?: InputMaybe<Scalars['Int']>;
  referenceId?: InputMaybe<Scalars['String']>;
  storeCardFlag?: InputMaybe<Scalars['Boolean']>;
  successUrl: Scalars['String'];
  transactionType?: InputMaybe<Scalars['String']>;
};

export type CardPaymentResponse = {
  __typename?: 'CardPaymentResponse';
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type Channels = {
  __typename?: 'Channels';
  email: Scalars['Boolean'];
  push: Scalars['Boolean'];
};

export type ChannelsInput = {
  email: Scalars['Boolean'];
  push: Scalars['Boolean'];
};

export type Client = {
  __typename?: 'Client';
  phoneNumber: Scalars['String'];
  type: Scalars['String'];
};

export type ConfirmBankTransferResponse = {
  __typename?: 'ConfirmBankTransferResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess: Scalars['Boolean'];
};

export type ContactRmInput = {
  contactMethod: Scalars['String'];
  contactMethodValue: Scalars['String'];
  message: Scalars['String'];
  subject: Scalars['String'];
};

export type ContactRmResponse = {
  __typename?: 'ContactRmResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type CosmosAsset = {
  __typename?: 'CosmosAsset';
  id: Scalars['Int'];
  spread?: Maybe<CosmosSpread>;
  unitCount?: Maybe<Scalars['Int']>;
  unitSize?: Maybe<Scalars['String']>;
  vintage?: Maybe<CosmosVintage>;
};

export type CosmosBidOffer = {
  __typename?: 'CosmosBidOffer';
  price?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
};

export type CosmosCalculatedMarketData = {
  __typename?: 'CosmosCalculatedMarketData';
  combinedScore?: Maybe<Scalars['String']>;
};

export type CosmosExecutableWindow = {
  __typename?: 'CosmosExecutableWindow';
  endTime?: Maybe<Scalars['String']>;
};

export type CosmosRegion = {
  __typename?: 'CosmosRegion';
  name?: Maybe<Scalars['String']>;
};

export type CosmosSpread = {
  __typename?: 'CosmosSpread';
  highestBid?: Maybe<CosmosBidOffer>;
  lowestOffer?: Maybe<CosmosBidOffer>;
  percentageDifference?: Maybe<Scalars['String']>;
};

export type CosmosVintage = {
  __typename?: 'CosmosVintage';
  calculatedMarketData?: Maybe<CalculatedMarketData>;
  id?: Maybe<Scalars['Int']>;
  imageFileName?: Maybe<Scalars['String']>;
  vintage?: Maybe<Scalars['Int']>;
  wine?: Maybe<CosmosWine>;
};

export type CosmosWine = {
  __typename?: 'CosmosWine';
  appellation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<CosmosRegion>;
};

export type CostBreakDownInput = {
  assetId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  dutyTo?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  unitPrice: Scalars['Float'];
  wineOriginCountry?: InputMaybe<Scalars['String']>;
};

export type CostBreakDownResult = {
  __typename?: 'CostBreakDownResult';
  deliveryFee?: Maybe<Scalars['Float']>;
  deliveryFeeVat?: Maybe<Scalars['Float']>;
  dutyFee?: Maybe<Scalars['Float']>;
  dutyFeeVat?: Maybe<Scalars['Float']>;
  insuranceFee?: Maybe<Scalars['Float']>;
  quantity: Scalars['Float'];
  totalDuties?: Maybe<Scalars['Float']>;
  totalPrice: Scalars['Float'];
  totalPricePlusFees?: Maybe<Scalars['Float']>;
  totalVat?: Maybe<Scalars['Float']>;
  transactionFee: Scalars['Float'];
  unitPrice: Scalars['Float'];
  universalTaxFee?: Maybe<Scalars['Float']>;
  validReward: Scalars['Float'];
  vatFee: Scalars['Float'];
  vatOnWine?: Maybe<Scalars['Float']>;
};

export type CountryCurrency = {
  __typename?: 'CountryCurrency';
  countryCode: Scalars['String'];
  currency: Scalars['String'];
};

export type CreateClientQueryInput = {
  emailAddress?: InputMaybe<Scalars['String']>;
  isLoggedIn?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type CreateClientQueryResponse = {
  __typename?: 'CreateClientQueryResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<CreateClientQueryResult>;
  status?: Maybe<Scalars['String']>;
};

export type CreateClientQueryResult = {
  __typename?: 'CreateClientQueryResult';
  createdDateTime?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  messageType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};

export type CreateFeedbackInput = {
  content: Scalars['String'];
  feedbackType?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<FeedbackImageInput>>;
};

export type CreateFeedbackResponse = {
  __typename?: 'CreateFeedbackResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<CreateFeedbackResult>;
  status: Scalars['String'];
};

export type CreateFeedbackResult = {
  __typename?: 'CreateFeedbackResult';
  attachmentBlobNames?: Maybe<Array<Scalars['String']>>;
  content: Scalars['String'];
  createdDateTime: Scalars['String'];
  feedbackType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  userId: Scalars['String'];
};

export type CreateOrderInput = {
  assetId: Scalars['Int'];
  cancelAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fillOrKill?: InputMaybe<Scalars['Boolean']>;
  limitFXExposure?: InputMaybe<Scalars['Boolean']>;
  operationType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  targetPortfolioId?: InputMaybe<Scalars['String']>;
  totalPrice?: InputMaybe<Scalars['Float']>;
};

export type CreditForAccountResponse = {
  __typename?: 'CreditForAccountResponse';
  errorMessage?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CreditLimitAndBalanceResponse = {
  __typename?: 'CreditLimitAndBalanceResponse';
  availableTradingHeadroom: Scalars['Float'];
  balance: Scalars['Float'];
  bidCapacity?: Maybe<Scalars['Float']>;
  bidMultiplier: Scalars['Float'];
  creditLimit: Scalars['Float'];
  errorMessage?: Maybe<Scalars['String']>;
  foa: Scalars['Float'];
  initTradeHeadroom: Scalars['Float'];
};

export type CustomReferralCodeResult = {
  __typename?: 'CustomReferralCodeResult';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DefaultMitCardInput = {
  instrumentId: Scalars['String'];
};

export type DeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type DeleteUserQuickSearchResponse = {
  __typename?: 'DeleteUserQuickSearchResponse';
  errorMessage?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type DeliveryAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  dutyTo?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
};

export type DeliveryCostBreakDownInput = {
  assetUnitIds: Array<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  dutyTo?: InputMaybe<Scalars['String']>;
};

export type DeliveryCostBreakDownResponse = {
  __typename?: 'DeliveryCostBreakDownResponse';
  results: Array<DeliveryCostBreakDownResult>;
  validReward: Scalars['Float'];
};

export type DeliveryCostBreakDownResult = {
  __typename?: 'DeliveryCostBreakDownResult';
  deliveryFee?: Maybe<Scalars['Float']>;
  deliveryFeeVat?: Maybe<Scalars['Float']>;
  dutyFee?: Maybe<Scalars['Float']>;
  dutyFeeVat?: Maybe<Scalars['Float']>;
  insuranceFee?: Maybe<Scalars['Float']>;
  quantity: Scalars['Float'];
  totalDuties?: Maybe<Scalars['Float']>;
  totalPrice: Scalars['Float'];
  totalPricePlusFees?: Maybe<Scalars['Float']>;
  totalVat?: Maybe<Scalars['Float']>;
  transactionFee: Scalars['Float'];
  unitPrice: Scalars['Float'];
  universalTaxFee?: Maybe<Scalars['Float']>;
  vatFee: Scalars['Float'];
  vatOnWine?: Maybe<Scalars['Float']>;
};

export type DeliveryRequest = {
  __typename?: 'DeliveryRequest';
  address: DeliveryRequestAddress;
  currentStatus?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  orderRef: Scalars['String'];
  requestType?: Maybe<Scalars['String']>;
  requestedDate?: Maybe<Scalars['String']>;
  statusHistory: Array<DeliveryRequestStatusHistory>;
  wines: Array<DeliveryRequestWine>;
};

export type DeliveryRequestAddress = {
  __typename?: 'DeliveryRequestAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
};

export type DeliveryRequestStatusHistory = {
  __typename?: 'DeliveryRequestStatusHistory';
  changeSource?: Maybe<Scalars['String']>;
  changedAt?: Maybe<Scalars['String']>;
  newStockStatus: Scalars['String'];
  previousStockStatus?: Maybe<Scalars['String']>;
};

export type DeliveryRequestWine = {
  __typename?: 'DeliveryRequestWine';
  appellation?: Maybe<Scalars['String']>;
  assetId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  unitCountUnitSize?: Maybe<Scalars['String']>;
  units: Scalars['Int'];
  vintage?: Maybe<Scalars['Int']>;
};

export type DeliveryTransactionBreakDown = {
  __typename?: 'DeliveryTransactionBreakDown';
  tag?: Maybe<Scalars['String']>;
  transactionValueGBP?: Maybe<Scalars['String']>;
};

export type DeliveryTransactionResponse = {
  __typename?: 'DeliveryTransactionResponse';
  breakDown: Array<DeliveryTransactionBreakDown>;
  result?: Maybe<DeliveryTransactionResult>;
};

export type DeliveryTransactionResult = {
  __typename?: 'DeliveryTransactionResult';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  bestContactNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  deliveryInstructions?: Maybe<Scalars['String']>;
  dutyTo?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  oderId?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  requestStatus?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
  requestedDate?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
  uniqReference?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['String']>;
};

export type DrinkingWindow = {
  __typename?: 'DrinkingWindow';
  advice?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
};

export type EmailValidationResult = {
  __typename?: 'EmailValidationResult';
  isSuccess?: Maybe<Scalars['Boolean']>;
  result?: Maybe<EmailValidationResultType>;
};

export enum EmailValidationResultType {
  INVALID = 'INVALID',
  REGISTERED = 'REGISTERED',
  VALID = 'VALID'
}

export type Event_And_Experience = {
  __typename?: 'Event_And_Experience';
  date: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  price: Scalars['Int'];
  time: Scalars['String'];
  title: Scalars['String'];
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  currency: Scalars['String'];
  exchangeRate: Scalars['Float'];
  exchangeRateDate: Scalars['String'];
  id: Scalars['String'];
};

export type ExecutableWindow = {
  __typename?: 'ExecutableWindow';
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type ExternalPortfolioAsset = {
  __typename?: 'ExternalPortfolioAsset';
  addedToExternalPortfolioDate: Scalars['String'];
  asset: Asset;
  assetId: Scalars['Int'];
  calculatedMarketData: CalculatedMarketData;
  id: Scalars['Int'];
  purchaseDate?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  quantityOwned: Scalars['Int'];
  totalPurchasePrice: Scalars['Float'];
};

export type ExternalPortfolioInstance = {
  __typename?: 'ExternalPortfolioInstance';
  id: Scalars['Int'];
  purchaseDate?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
};

export type FeeItems = {
  type: FeeType;
  value: Scalars['Float'];
};

export enum FeeType {
  TRANSACTION_FEES = 'TRANSACTION_FEES',
  VAT_FEES = 'VAT_FEES'
}

export type FeedbackImageInput = {
  base64: Scalars['String'];
  filename: Scalars['String'];
  mimeType: Scalars['String'];
};

export type FinalizePaymentSessionInput = {
  paymentId: Scalars['String'];
};

export type FinalizePaymentSessionResponse = {
  __typename?: 'FinalizePaymentSessionResponse';
  errorMessage?: Maybe<Scalars['String']>;
  providerPaymentId?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type FinancialAvailableWithdrawalAmount = {
  __typename?: 'FinancialAvailableWithdrawalAmount';
  currentWithdrawalGbp: Scalars['Float'];
};

export type FinancialOperation = {
  __typename?: 'FinancialOperation';
  operationAmountGbp: Scalars['Float'];
  operationCurrency: Scalars['String'];
  operationDate: Scalars['String'];
  operationSource?: Maybe<Scalars['String']>;
  operationType: OperationType;
};

export type FinancialOperationCapitalInvestment = {
  __typename?: 'FinancialOperationCapitalInvestment';
  totalCapitalInvestedGbp: Scalars['Float'];
  userId: Scalars['String'];
};

export type FinancialOperationCurrentBalance = {
  __typename?: 'FinancialOperationCurrentBalance';
  cultWineId: Scalars['String'];
  currentBalanceGbp: Scalars['Float'];
};

export type FinancialOperationInput = {
  operationAmountGbp: Scalars['Float'];
  operationCurrency: Scalars['String'];
  operationDate: Scalars['String'];
  operationSource?: InputMaybe<Scalars['String']>;
  operationType: OperationType;
};

export type FinancialOperationMonthWiseFlow = {
  __typename?: 'FinancialOperationMonthWiseFlow';
  monthlyExpenses: Array<MonthlyExpense>;
};

export type FinancialRecentOperation = {
  __typename?: 'FinancialRecentOperation';
  operationAmountGbp: Scalars['Float'];
  operationCurrency: Scalars['String'];
  operationDate: Scalars['String'];
  operationSource?: Maybe<Scalars['String']>;
  operationType: Scalars['String'];
  userId: Scalars['String'];
};

export type GeneratePortfolioInput = {
  capital: Scalars['Float'];
  geoAllocation: Scalars['Boolean'];
  liquidityProfile: Scalars['String'];
  riskProfile: Scalars['String'];
  userIdIn?: InputMaybe<Scalars['String']>;
};

export type GenerateSettlementReferenceInput = {
  prefix?: InputMaybe<Scalars['String']>;
  randomCharLength?: InputMaybe<Scalars['Int']>;
  tradeAccountId?: InputMaybe<Scalars['String']>;
};

export type GeneratedPortfolioResponse = {
  __typename?: 'GeneratedPortfolioResponse';
  errorMessage?: Maybe<Scalars['String']>;
  results: Array<Maybe<GeneratedPortfolioResult>>;
};

export type GeneratedPortfolioResult = {
  __typename?: 'GeneratedPortfolioResult';
  aiExplainer?: Maybe<Scalars['String']>;
  appellation?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  highestBid?: Maybe<Scalars['Float']>;
  imageFilename?: Maybe<Scalars['String']>;
  lowestOffer?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
  productUrn?: Maybe<Scalars['String']>;
  quantityAavailable?: Maybe<Scalars['Int']>;
  quantitySelected?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  unitCount?: Maybe<Scalars['Int']>;
  unitSize?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
  vintage?: Maybe<Scalars['Int']>;
  wineName?: Maybe<Scalars['String']>;
};

export type GeneratedReferralCodeResult = {
  __typename?: 'GeneratedReferralCodeResult';
  data?: Maybe<ReferralCodeData>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  hasAliasCode?: Maybe<Scalars['Boolean']>;
  hasTrades?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GeneratorResponse = {
  __typename?: 'GeneratorResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
};

export type GetDistinctProducersResponse = {
  __typename?: 'GetDistinctProducersResponse';
  id: Scalars['Int'];
  producer: Scalars['String'];
};

export type GetDistinctRegionsResponse = {
  __typename?: 'GetDistinctRegionsResponse';
  id: Scalars['Int'];
  region: Scalars['String'];
};

export type GetTransactionHistoryResponse = {
  __typename?: 'GetTransactionHistoryResponse';
  lastMonth: Scalars['Int'];
  lastWeek: Scalars['Int'];
  lastYear: Scalars['Int'];
  lwin11?: Maybe<Scalars['String']>;
  results: Array<Maybe<GetTransactionHistoryResults>>;
  totalPages: Scalars['Int'];
  totalRecords: Scalars['Int'];
  vintage?: Maybe<Scalars['String']>;
  wineName?: Maybe<Scalars['String']>;
};

export type GetTransactionHistoryResults = {
  __typename?: 'GetTransactionHistoryResults';
  dealDate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  unitSize?: Maybe<Scalars['String']>;
};

export type Get_Stock = {
  __typename?: 'Get_Stock';
  changedPct: Scalars['Int'];
  costPerUnit: Scalars['Int'];
  costWithMgmtFeePerUnit: Scalars['Int'];
  cultWinesAllocationRegion: Scalars['String'];
  dealCCY?: Maybe<Scalars['String']>;
  dealDate: Scalars['String'];
  dealRef: Scalars['String'];
  historicMarketPrices?: Maybe<Array<Maybe<HistoricMarketPrices>>>;
  holdingStocks?: Maybe<Array<Maybe<HoldingStock>>>;
  id: Scalars['String'];
  lwin18: Scalars['Int'];
  mgmtFeePerUnit: Scalars['Int'];
  netPosition: Scalars['Int'];
  netPositionPerUnit: Scalars['Int'];
  portfolioId: Scalars['Int'];
  priceForSale: Scalars['Int'];
  profitAndLoss: Scalars['Int'];
  profitAndLostPerUnit: Scalars['Int'];
  qty: Scalars['Int'];
  qtyForSale: Scalars['Int'];
  region: Scalars['String'];
  totalCost: Scalars['Int'];
  totalCostWithMgmtFee: Scalars['Int'];
  totalMgmtFee: Scalars['Int'];
  totalValue: Scalars['Int'];
  unit?: Maybe<Scalars['String']>;
  unitCount: Scalars['Int'];
  valuePerBottle: Scalars['Int'];
  valuePerUnit: Scalars['Int'];
  vintage: Scalars['String'];
  wineName: Scalars['String'];
};

export type HistoricMarketPriceItem = {
  __typename?: 'HistoricMarketPriceItem';
  date: Scalars['String'];
  marketPrice: Scalars['Float'];
};

export type HistoricMarketPrices = {
  __typename?: 'HistoricMarketPrices';
  date: Scalars['String'];
  marketPrice: Scalars['Int'];
};

export type HistoricalMarketData = {
  __typename?: 'HistoricalMarketData';
  assetId: Scalars['Int'];
  liveX: Scalars['JSON'];
  lwin18: Scalars['String'];
  wineSearcher: Scalars['JSON'];
};

export type HistoricalMarketDataChange = {
  __typename?: 'HistoricalMarketDataChange';
  assetId: Scalars['Int'];
  liveX: Scalars['JSON'];
  lwin18: Scalars['String'];
  wineSearcher: Scalars['JSON'];
};

export type Holding = {
  __typename?: 'Holding';
  assetId: Scalars['Int'];
  buyingTransactionId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  sellingTransactionId?: Maybe<Scalars['String']>;
  soldTransactionDate?: Maybe<Scalars['String']>;
  soldTransactionPrice?: Maybe<Scalars['Float']>;
  unitSizeId: Scalars['Int'];
  vintageId: Scalars['Int'];
};

export type HoldingItem = {
  __typename?: 'HoldingItem';
  activeOfferQuantity: Scalars['Int'];
  totalMarketValuation: Scalars['Float'];
  totalPurchasePrice: Scalars['Float'];
  totalQuantityOwned: Scalars['Int'];
};

export type HoldingPerformanceResponse = {
  __typename?: 'HoldingPerformanceResponse';
  percentageDifference?: Maybe<Scalars['Float']>;
  valueDifference?: Maybe<Scalars['Float']>;
};

export type HoldingPurchaseDateDto = {
  __typename?: 'HoldingPurchaseDateDto';
  purchaseDate?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
};

export type HoldingResponse = {
  __typename?: 'HoldingResponse';
  assetId: Scalars['Int'];
  buyingTransactionId: Scalars['Int'];
  sellingTransactionId?: Maybe<Scalars['Int']>;
  unitSizeId: Scalars['Int'];
  vintageId: Scalars['Int'];
};

export type HoldingResult = {
  __typename?: 'HoldingResult';
  appellation?: Maybe<Scalars['String']>;
  assetId: Scalars['Int'];
  calculatedMarketData: CalculatedMarketData;
  cultWineId: Scalars['String'];
  docId: Scalars['String'];
  drinkingWindow: WineVintageDrinkingWindow;
  holding: HoldingItem;
  marketValue: Scalars['Float'];
  portfolioId: Scalars['Int'];
  region: Scalars['String'];
  score: Scalars['Int'];
  spread?: Maybe<OrderSpread>;
  totalPurchasedPrice: Scalars['Float'];
  unitCount: Scalars['Int'];
  unitSize: Scalars['String'];
  vintage: Scalars['Int'];
  wineName: Scalars['String'];
};

export type HoldingStock = {
  __typename?: 'HoldingStock';
  location: Scalars['String'];
  rotationNumber: Scalars['String'];
  status: Scalars['String'];
};

export type HoldingTimeSeries = {
  __typename?: 'HoldingTimeSeries';
  date: Scalars['String'];
  holdings: Array<HoldingResponse>;
};

export type HubSpotCustomer = {
  __typename?: 'HubSpotCustomer';
  addressline1?: Maybe<Scalars['String']>;
  addressline2?: Maybe<Scalars['String']>;
  addressline3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type IBookedOrder = {
  __typename?: 'IBookedOrder';
  assetId: Scalars['Int'];
  direction: Scalars['Int'];
  id: Scalars['ID'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  status: Scalars['String'];
  submittedTimeUtc: Scalars['String'];
  userId: Scalars['ID'];
};

export type IFilledOrder = {
  __typename?: 'IFilledOrder';
  assetId: Scalars['Int'];
  direction: Scalars['Int'];
  filledType: OrderFillType;
  id: Scalars['ID'];
  originalOrder: IBookedOrder;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  submittedTimeUtc: Scalars['String'];
  userId: Scalars['ID'];
};

export type IGetSupportMessageByUserId = {
  __typename?: 'IGetSupportMessageByUserId';
  count?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<IMessageObject>>>;
};

export type IGetSupportMessageByUserIdInput = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type IMessageObject = {
  __typename?: 'IMessageObject';
  createdDateTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  messageType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  sourceQueryId?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};

export type ISendSupportMessage = {
  __typename?: 'ISendSupportMessage';
  data?: Maybe<ISendSupportMessageData>;
};

export type ISendSupportMessageData = {
  __typename?: 'ISendSupportMessageData';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<SendMessageResult>;
  status?: Maybe<Scalars['String']>;
};

export type ISendSupportMessageInput = {
  message?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  sourceQueryId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type ImsRegionSummary = {
  __typename?: 'ImsRegionSummary';
  regionName: Scalars['String'];
  totalBottles: Scalars['Int'];
};

export type InitRedeemData = {
  __typename?: 'InitRedeemData';
  status?: Maybe<Scalars['String']>;
};

export type InitRedeemInput = {
  code: Scalars['String'];
  source?: InputMaybe<InitRedeemSource>;
};

export type InitRedeemResult = {
  __typename?: 'InitRedeemResult';
  data?: Maybe<InitRedeemData>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum InitRedeemSource {
  Onboarding = 'Onboarding',
  RewardPage = 'RewardPage'
}

export type InvoiceItemsResponse = {
  __typename?: 'InvoiceItemsResponse';
  assetUnitId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['Int']>;
};

export type InvoicePdfResponse = {
  __typename?: 'InvoicePDFResponse';
  base64Data?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
};

export type InvoiceTransactionStatus = {
  __typename?: 'InvoiceTransactionStatus';
  displayStatus: Scalars['String'];
  effectiveAgeDays: Scalars['Int'];
  invoiceId: Scalars['Int'];
  reference?: Maybe<Scalars['String']>;
  settlementRequestId?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  tradeId: Scalars['String'];
};

export type InvoiceTransactionStatusResponse = {
  __typename?: 'InvoiceTransactionStatusResponse';
  data: Array<Maybe<InvoiceTransactionStatus>>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type InvoicesResponse = {
  __typename?: 'InvoicesResponse';
  assetId: Scalars['Int'];
  caseSize: Scalars['String'];
  invoiceId: Scalars['Int'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  tradeDateTime: Scalars['String'];
  tradeId: Scalars['String'];
  transferRequested?: Maybe<Scalars['Boolean']>;
  vintage: Scalars['Int'];
  wineName: Scalars['String'];
};

export type KycInitiateInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  county: Scalars['String'];
  dob: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  postcode: Scalars['String'];
  town?: InputMaybe<Scalars['String']>;
};

export type KycInitiateResponse = {
  __typename?: 'KycInitiateResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isKycInitiated: Scalars['Boolean'];
};

export enum KycStatus {
  failed = 'failed',
  not_attempted = 'not_attempted',
  pending = 'pending',
  successful = 'successful'
}

export type Learning_Hub = {
  __typename?: 'Learning_Hub';
  date: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type LiveActiveMarket = {
  __typename?: 'LiveActiveMarket';
  assetId: Scalars['Int'];
  highestBid?: Maybe<ActiveMarketOrder>;
  imageFileName?: Maybe<Scalars['String']>;
  lowestOffer?: Maybe<ActiveMarketOrder>;
  lwin18: Scalars['String'];
  marketValue?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  spread?: Maybe<Scalars['Float']>;
  toBeRemove?: Maybe<Scalars['Boolean']>;
  unitCount?: Maybe<Scalars['Int']>;
  unitSize?: Maybe<Scalars['String']>;
  vintage?: Maybe<Scalars['Int']>;
  wineName?: Maybe<Scalars['String']>;
};

export type LiveActiveMarketResult = {
  __typename?: 'LiveActiveMarketResult';
  result: LiveActiveMarket;
  total: Scalars['Int'];
};

export type LiveBidValidationResponse = {
  __typename?: 'LiveBidValidationResponse';
  isValidBid: Scalars['Boolean'];
  newBidPrice: Scalars['Float'];
  prevBidPrice?: Maybe<Scalars['Float']>;
  totalBidPricePlusFees: Scalars['Float'];
};

export type LockStocksForDeliveryInput = {
  assetUnitIds: Array<Scalars['String']>;
  bestContactNumber?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
  deliveryInstructions?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<Scalars['String']>;
};

export type LockStocksInput = {
  assetId: Scalars['Int'];
  bestContactNumber?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
  deliveryInstructions?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  totalPrice: Scalars['Float'];
};

export type LockStocksResponse = {
  __typename?: 'LockStocksResponse';
  assetUnitIds?: Maybe<Array<Scalars['String']>>;
  clientOrderIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  errorMessage?: Maybe<Scalars['String']>;
  initiated: Scalars['Boolean'];
  referenceId?: Maybe<Scalars['String']>;
};

export type LotDetail = {
  __typename?: 'LotDetail';
  caseFormat: Scalars['String'];
  conditionNotes: Scalars['String'];
  lotRef: Scalars['String'];
  photographedAt: Scalars['String'];
  warehouse: Scalars['String'];
};

export type LotPhoto = {
  __typename?: 'LotPhoto';
  caption?: Maybe<Scalars['String']>;
  capturedAt: Scalars['String'];
  id: Scalars['ID'];
  uri: Scalars['String'];
};

/**
 * Photo state for an offer/lot. LOT = parcel-specific photos; REFERENCE = representative
 * warehouse profile photos; NONE = no photos but CultX guarantee still applies.
 */
export enum LotPhotoState {
  LOT = 'LOT',
  NONE = 'NONE',
  REFERENCE = 'REFERENCE'
}

export type LotPickerData = {
  __typename?: 'LotPickerData';
  hasAnyPhotos: Scalars['Boolean'];
  rows: Array<LotPickerRow>;
  totalCases: Scalars['Int'];
  unitDescriptor: Scalars['String'];
};

/**
 * One row in the order-book lot picker popover. A cell at a given price/quantity
 * can group multiple underlying lots; each row represents one lot or a bundle of
 * lots that share the same photo state.
 */
export type LotPickerRow = {
  __typename?: 'LotPickerRow';
  caseCount: Scalars['Int'];
  id: Scalars['ID'];
  label: Scalars['String'];
  photoCount?: Maybe<Scalars['Int']>;
  state: LotPhotoState;
  sub: Scalars['String'];
};

export type MarkNotificationsReadRequest = {
  ids: Array<Scalars['String']>;
  isRead: Scalars['Boolean'];
};

export type MarketData = {
  __typename?: 'MarketData';
  liveX: Scalars['JSON'];
  lwin18?: Maybe<Scalars['String']>;
  performance: HoldingPerformanceResponse;
  wineSearcher: Scalars['JSON'];
};

export type MgmtFeeDetail = {
  __typename?: 'MgmtFeeDetail';
  applied: Scalars['Int'];
  feeAmount: Scalars['Int'];
  feeType: Scalars['String'];
  id: Scalars['String'];
  invoiceDate: Scalars['String'];
  invoiceNumber: Scalars['String'];
  name: Scalars['String'];
  offsetValue?: Maybe<Scalars['String']>;
  portfolioValue?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  valuationDate: Scalars['String'];
};

export type MiscellaneousItem = {
  __typename?: 'MiscellaneousItem';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  symbol?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type MiscellaneousType = {
  __typename?: 'MiscellaneousType';
  currencies?: Maybe<Array<Maybe<MiscellaneousItem>>>;
  languages?: Maybe<Array<Maybe<MiscellaneousItem>>>;
  paymentFrequencies?: Maybe<Array<Maybe<MiscellaneousItem>>>;
};

export type MonthlyExpense = {
  __typename?: 'MonthlyExpense';
  inward: Scalars['Float'];
  monthDate: Scalars['String'];
  monthName: Scalars['String'];
  outward: Scalars['Float'];
  purchase: Scalars['Float'];
  sale: Scalars['Float'];
};

export type MoveWatchlistGroupResponse = {
  __typename?: 'MoveWatchlistGroupResponse';
  movedAssetIds: Array<Scalars['Int']>;
  targetGroupId: Scalars['Int'];
  targetGroupName: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountDeletion: DeleteAccountResponse;
  addAssetToWatchList: AddToWatchListResponse;
  addAssetToWatchListBatch: Array<AddToWatchListResponse>;
  addPaymentDetail: PaymentDetailResponse;
  /**
   * Connect device to push notifications
   *
   * Equivalent to POST /UserDeviceTokens
   */
  addUserDeviceToken: UserDeviceToken;
  addWatchListGroup: Array<AddWatchListGroupResult>;
  /**
   * Allow user to change password.
   *
   * Equivalent to POST /Auth/ChangePassword
   */
  authChangePassword: AuthChangePasswordResponse;
  authCnLogin: AuthLoginResponse;
  authCnRegister: AuthCnUser;
  authCreateBiometric: AuthCreateBiometricResponse;
  /**
   * Sign in via Auth0
   *
   * Equivalent to POST /Auth/Login
   */
  authLogin: AuthLoginResponse;
  authLoginWithBiometric: AuthLoginResponse;
  authMfaAuthenticators: AuthGetMfaAuthenticatorsResponse;
  authMfaChallenge: AuthMfaChallengeResponse;
  /** Verify code sent to oob authenticator (e.g. code sent to email) */
  authMfaVerify: AuthMfaOobCodeVerifyResponse;
  /**
   * Get fresh access token from refresh token
   *
   * Equivalent to POST /Auth/RefreshAccessToken
   */
  authRefreshAccessToken: AuthRefreshAccessTokenResponse;
  /** Create new user record and also create equivalent Authentication Provider record */
  authRegister: AuthUser;
  authResendVerificationEmail: AuthResendVerificationEmailResponse;
  /**
   * If there is no user found with the specified address, this endpoint will still return a 200 response.
   *
   * Equivalent to POST /Auth/ResetPassword
   */
  authResetPassword: AuthResetPasswordResponse;
  /**
   * Update user record
   *
   * Equivalent to PUT /Auth/User
   */
  authUserUpdate: AuthUser;
  bankTransferConfirm: BankTransferConfirmResponse;
  bid: Scalars['ID'];
  buyItNow: BuyItNowInitiatedResponse;
  buyItNowBatch: Array<BuyItNowInitiatedResponse>;
  buyItNowInBatch: Array<BuyItNowInitiatedResponse>;
  cancelOrder: Scalars['ID'];
  cancelOrderBatch: Array<Scalars['ID']>;
  cancelPausedBids: CancelPausedBidsResponse;
  cancelSettlementRequests: CancelSettlementRequestsResponse;
  cancelStripeRecurringPayment: CancelStripeRecurringPaymentResponse;
  confirmManualBankTransfer: ConfirmBankTransferResponse;
  createCardPayment: CardPaymentResponse;
  createClientQuery: CreateClientQueryResponse;
  createFeedback: CreateFeedbackResponse;
  createPaymentResource: Scalars['String'];
  createPaymentSession: PaymentSessionResponse;
  createStripePayment: StripePaymentResponse;
  createStripeRecurringPayment: StripeRecurringPaymentResponse;
  createWatchlistGroup: WatchlistGroup;
  deleteAssetFromWatchList: Scalars['Int'];
  deleteAssetFromWatchListBatch: Array<Scalars['Int']>;
  deleteCardDetail: CardDetailDeletedResult;
  deletePaymentDetail: Scalars['Boolean'];
  deleteUserQuickSearch: DeleteUserQuickSearchResponse;
  deleteWatchlistGroup: Array<Scalars['Int']>;
  enableCreditForAccount: CreditForAccountResponse;
  externalPortfolioAddExternalPortfolio: Scalars['Int'];
  externalPortfolioAddExternalPortfolioBatch: Array<AddExternalPortfolioBatchResponse>;
  externalPortfolioDeleteExternalPortfolio: Scalars['Boolean'];
  externalPortfolioRemoveFromExternalPortfolio: Scalars['Int'];
  finalizePaymentSession: FinalizePaymentSessionResponse;
  generatePortfolio: GeneratorResponse;
  generateSettlementReference: Scalars['String'];
  generateWineRecommendations: GeneratorResponse;
  initRedeem: InitRedeemResult;
  /** Kyc initiate */
  kycInitiate: KycInitiateResponse;
  lockStocks: LockStocksResponse;
  lockStocksForDelivery: LockStocksResponse;
  /** Equivalent to POST /ReadNotifications */
  markNotificationsRead: Scalars['Boolean'];
  moveWatchlistGroup: MoveWatchlistGroupResponse;
  offer: Scalars['ID'];
  partnersAuthLogin: PartnersAuthLoginResponse;
  partnersAuthRefreshAccessToken: PartnersAuthRefreshAccessTokenResponse;
  portalAuthLogin: AuthLoginResponse;
  portalAuthMfaAuthenticators: AuthGetMfaAuthenticatorsResponse;
  portalAuthMfaChallenge: AuthMfaChallengeResponse;
  portalAuthMfaVerify: AuthMfaOobCodeVerifyResponse;
  portalAuthRegister: AuthUser;
  portalAuthResetPassword: AuthResetPasswordResponse;
  portalBuyWine: PortalProcessWineResponse;
  portalContactRelationshipManger: ContactRmResponse;
  portalDeliverWine: PortalProcessWineResponse;
  portalDocument?: Maybe<Scalars['JSON']>;
  portalInvestNow: PortalProcessWineResponse;
  portalSellWine: PortalProcessWineResponse;
  portalUpdatePreferences: PortalClientPreferencesResponse;
  refreshReferralCode: GeneratedReferralCodeResult;
  registerWithMfa: RegisterWithMfaResponse;
  reinstateBids: Array<ReinstateBidInitiatedResponse>;
  /**
   * Remove device from push notifications
   *
   * Equivalent to DELETE /UserDeviceTokens
   */
  removeUserDeviceToken: Scalars['Boolean'];
  renameWatchlistGroup: WatchlistGroup;
  /** Request lot-specific photos for a given lot row. Fee depends on the case price band. */
  requestLotPhotos: RequestLotPhotosResponse;
  rewardSetting: SetRewardSettingResult;
  saveBusinessAccount: BusinessAccountResponse;
  saveOnboardingSteps?: Maybe<SaveOnboardingStepsResponse>;
  savePortfolioGenerator?: Maybe<SavePortfolioGeneratorResponse>;
  saveSearchHistory?: Maybe<SaveSearchHistoryResult>;
  saveUserQuickSearch: Array<UserQuickSearch>;
  saveUserRegistration: SaveUserRegistrationResponse;
  saveWinePreferences: WinePreferenceResponse;
  saveWineRecommendation?: Maybe<WineRecommendationResponse>;
  /**
   * Search bids in Elastic Search
   *
   * Equivalent to GET /Search/SearchBid with indexName 'bid'
   */
  searchBids: SearchBidsResult;
  /**
   * Search holdings in Elastic Search
   *
   * Equivalent to GET /Search/SearchHolding with indexName 'holding'
   */
  searchHoldings: SearchHoldingResult;
  /**
   * Search offers in Elastic Search
   *
   * Equivalent to GET /Search/SearchOffer with indexName 'offer'
   */
  searchOffers: SearchOffersResult;
  /**
   * Search watchlist in Elastic Search
   *
   * Equivalent to GET /Search/SearchWatchlist with indexName 'watchlist'
   */
  searchWatchlist: SearchWatchlistResult;
  /**
   * Search wine vintages in Elastic Search
   *
   * Equivalent to GET /Search/SearchWineVintages with indexName 'wine-vintage'
   */
  searchWineVintages: SearchWineVintagesResult;
  searchWineVintagesFacets: SearchWineVintagesFacetsResult;
  setCustomReferralCode: SetCustomReferralCodeResult;
  settleInvoices: SettleInvoicesResponse;
  shareWatchlistAssets: ShareWatchlistResponse;
  shareWatchlistGroup: ShareWatchlistResponse;
  transferInventoryOut: Array<Scalars['String']>;
  transferInventoryOutV2: TransferInventoryOutV2Response;
  unlockStocks: UnlockStocksResponse;
  /**
   * Patch category
   *
   * Equivalent to PATCH /UpdateCategory
   */
  updateCategory: NotificationCategory;
  /**
   * Patch category type
   *
   * Equivalent to PATCH /UpdateCategoryType
   */
  updateCategoryType: NotificationCategoryType;
  updateCultxPreferences: UpdateCultxPreferencesResponse;
  updateDefaultMitCard: UpdateDefaultMitCardResponse;
  updateMitConsent: UpdateMitConsentResponse;
  /** Equivalent to Patch /UpdateNotification */
  updateNotification: Notification;
  updatePaymentDetail: PaymentDetailResponse;
  updateStripeRecurringPayment: UpdateStripeRecurringPaymentResponse;
  updateUserQuickSearch: Array<UserQuickSearch>;
  withdrawConfirmation: WithdrawConfirmationResponse;
  zellarClientAddAddress: Address;
  zellarClientDeleteAddress: AddressDeletedResult;
  zellarClientUpdateAddress: Address;
};


export type MutationAddAssetToWatchListArgs = {
  assetId: Scalars['Int'];
};


export type MutationAddAssetToWatchListBatchArgs = {
  assetIds: Array<Scalars['Int']>;
};


export type MutationAddPaymentDetailArgs = {
  input: AddPaymentDetailInput;
};


export type MutationAddUserDeviceTokenArgs = {
  deviceId: Scalars['String'];
  platform: Scalars['Int'];
};


export type MutationAddWatchListGroupArgs = {
  input: AddWatchListGroupInput;
};


export type MutationAuthChangePasswordArgs = {
  changePasswordInput: AuthChangePasswordInput;
};


export type MutationAuthCnLoginArgs = {
  cnLoginRequestInput: AuthCnLoginRequestInput;
};


export type MutationAuthCnRegisterArgs = {
  registerCnUserInput: AuthCnRegisterUserInput;
};


export type MutationAuthCreateBiometricArgs = {
  createBiometricRequestInput: AuthCreateBiometricRequestInput;
};


export type MutationAuthLoginArgs = {
  loginRequestInput: AuthLoginRequestInput;
};


export type MutationAuthLoginWithBiometricArgs = {
  loginRequestInput: AuthLoginWithBiometricRequestInput;
};


export type MutationAuthMfaAuthenticatorsArgs = {
  getMfaAuthenticatorsRequestInput: AuthGetMfaAuthenticatorsRequestInput;
};


export type MutationAuthMfaChallengeArgs = {
  mfaChallengeRequestInput: AuthMfaChallengeRequestInput;
};


export type MutationAuthMfaVerifyArgs = {
  mfaOobCodeVerifyRequestInput: AuthMfaOobCodeVerifyRequestInput;
};


export type MutationAuthRefreshAccessTokenArgs = {
  refreshAccessTokenRequestInput: AuthRefreshAccessTokenRequestInput;
};


export type MutationAuthRegisterArgs = {
  registerUserInput: AuthRegisterUserInput;
};


export type MutationAuthResendVerificationEmailArgs = {
  resendVerificationEmailInput: AuthResendVerificationEmailInput;
};


export type MutationAuthResetPasswordArgs = {
  resetPasswordInput: AuthResetPasswordInput;
};


export type MutationAuthUserUpdateArgs = {
  updateUserInput: AuthUpdateUserDtoInput;
};


export type MutationBankTransferConfirmArgs = {
  request: BankTransferPreferenceInput;
};


export type MutationBidArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationBuyItNowArgs = {
  buyItNowInitiatedInput?: InputMaybe<BuyItNowInitiatedInput>;
};


export type MutationBuyItNowBatchArgs = {
  buyItNowInitiatedInput?: InputMaybe<BuyItNowInitiatedInput>;
};


export type MutationBuyItNowInBatchArgs = {
  buyItNowInitiatedInput: Array<BuyItNowInitiatedInput>;
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationCancelOrderBatchArgs = {
  orderIds: Array<Scalars['ID']>;
};


export type MutationCancelPausedBidsArgs = {
  input: CancelPausedBidsInput;
};


export type MutationCancelSettlementRequestsArgs = {
  input?: InputMaybe<CancelSettlementRequestsInput>;
};


export type MutationCancelStripeRecurringPaymentArgs = {
  recurringPaymentId: Scalars['String'];
};


export type MutationCreateCardPaymentArgs = {
  cardPayment: CardPaymentInput;
};


export type MutationCreateClientQueryArgs = {
  input: CreateClientQueryInput;
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


export type MutationCreatePaymentResourceArgs = {
  paymentResource: PaymentResourceInput;
};


export type MutationCreatePaymentSessionArgs = {
  paymentSession: PaymentSessionInput;
};


export type MutationCreateStripePaymentArgs = {
  stripePayment: StripePaymentInput;
};


export type MutationCreateStripeRecurringPaymentArgs = {
  stripeRecurringPayment: StripeRecurringPaymentInput;
};


export type MutationCreateWatchlistGroupArgs = {
  name: Scalars['String'];
};


export type MutationDeleteAssetFromWatchListArgs = {
  assetId: Scalars['Int'];
};


export type MutationDeleteAssetFromWatchListBatchArgs = {
  assetIds: Array<Scalars['Int']>;
};


export type MutationDeleteCardDetailArgs = {
  instrumentId: Scalars['String'];
};


export type MutationDeletePaymentDetailArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserQuickSearchArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationDeleteWatchlistGroupArgs = {
  groupIds: Array<Scalars['Int']>;
};


export type MutationExternalPortfolioAddExternalPortfolioArgs = {
  externalPortfolio?: InputMaybe<AddExternalPortfolioInput>;
};


export type MutationExternalPortfolioAddExternalPortfolioBatchArgs = {
  externalPortfolios: Array<AddExternalPortfolioInput>;
};


export type MutationExternalPortfolioRemoveFromExternalPortfolioArgs = {
  externalPortfolioId: Scalars['Int'];
};


export type MutationFinalizePaymentSessionArgs = {
  finalizePaymentSession: FinalizePaymentSessionInput;
};


export type MutationGeneratePortfolioArgs = {
  generatePortfolioInput: GeneratePortfolioInput;
};


export type MutationGenerateSettlementReferenceArgs = {
  input?: InputMaybe<GenerateSettlementReferenceInput>;
};


export type MutationGenerateWineRecommendationsArgs = {
  recommendationInput: RecommendationInput;
};


export type MutationInitRedeemArgs = {
  input: InitRedeemInput;
};


export type MutationKycInitiateArgs = {
  kycInitiateInput: KycInitiateInput;
};


export type MutationLockStocksArgs = {
  lockStocksInput: LockStocksInput;
};


export type MutationLockStocksForDeliveryArgs = {
  lockStocksForDeliveryInput: LockStocksForDeliveryInput;
};


export type MutationMarkNotificationsReadArgs = {
  request: MarkNotificationsReadRequest;
};


export type MutationMoveWatchlistGroupArgs = {
  assetIds: Array<Scalars['Int']>;
  targetGroupId: Scalars['Int'];
};


export type MutationOfferArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationPartnersAuthLoginArgs = {
  partnersAuthLoginInput?: InputMaybe<PartnersAuthLoginInput>;
};


export type MutationPartnersAuthRefreshAccessTokenArgs = {
  partnersAuthRefreshAccessTokenInput?: InputMaybe<PartnersAuthRefreshAccessTokenInput>;
};


export type MutationPortalAuthLoginArgs = {
  loginRequestInput: AuthLoginRequestInput;
};


export type MutationPortalAuthMfaAuthenticatorsArgs = {
  getMfaAuthenticatorsRequestInput: AuthGetMfaAuthenticatorsRequestInput;
};


export type MutationPortalAuthMfaChallengeArgs = {
  mfaChallengeRequestInput: AuthMfaChallengeRequestInput;
};


export type MutationPortalAuthMfaVerifyArgs = {
  mfaOobCodeVerifyRequestInput: AuthMfaOobCodeVerifyRequestInput;
};


export type MutationPortalAuthRegisterArgs = {
  registerUserInput: PortalAuthRegisterUserInput;
};


export type MutationPortalAuthResetPasswordArgs = {
  resetPasswordInput: AuthResetPasswordInput;
};


export type MutationPortalBuyWineArgs = {
  portalBuyWineRequest: PortalBuyWineRequestInput;
};


export type MutationPortalContactRelationshipMangerArgs = {
  request: ContactRmInput;
};


export type MutationPortalDeliverWineArgs = {
  portalDeliverWineRequest: PortalDeliverWineRequestInput;
};


export type MutationPortalDocumentArgs = {
  data?: InputMaybe<Scalars['JSON']>;
  docRef?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
};


export type MutationPortalInvestNowArgs = {
  portalInvestNowRequest: PortalInvestNowRequestInput;
};


export type MutationPortalSellWineArgs = {
  portalSellWineRequest: PortalSellWineRequestInput;
};


export type MutationPortalUpdatePreferencesArgs = {
  request: UpdatePreferencesInput;
};


export type MutationRefreshReferralCodeArgs = {
  codeLength?: InputMaybe<Scalars['Int']>;
};


export type MutationRegisterWithMfaArgs = {
  registerWithMfaInput: RegisterWithMfaInput;
};


export type MutationReinstateBidsArgs = {
  reinstateBidInitiatedInput?: InputMaybe<ReinstateBidInitiatedInput>;
};


export type MutationRemoveUserDeviceTokenArgs = {
  id: Scalars['String'];
};


export type MutationRenameWatchlistGroupArgs = {
  groupId: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationRequestLotPhotosArgs = {
  assetId: Scalars['Int'];
  lotRowId: Scalars['ID'];
};


export type MutationRewardSettingArgs = {
  preference?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSaveBusinessAccountArgs = {
  businessAccountInput: BusinessAccountInput;
};


export type MutationSaveOnboardingStepsArgs = {
  step: Scalars['Int'];
};


export type MutationSavePortfolioGeneratorArgs = {
  savePortfolioGeneratorInput?: InputMaybe<SavePortfolioGeneratorInput>;
};


export type MutationSaveSearchHistoryArgs = {
  assetId?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  lwin7?: InputMaybe<Scalars['String']>;
  lwin18?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<Scalars['String']>;
};


export type MutationSaveUserQuickSearchArgs = {
  input: Array<UserQuickSearchInput>;
};


export type MutationSaveUserRegistrationArgs = {
  saveUserRegistrationInput?: InputMaybe<SaveUserRegistrationInput>;
};


export type MutationSaveWinePreferencesArgs = {
  winePreferenceInput: WinePreferenceInput;
};


export type MutationSaveWineRecommendationArgs = {
  saveWineRecommendationInput?: InputMaybe<WineRecommendationInput>;
};


export type MutationSearchBidsArgs = {
  filterNames: Array<Scalars['String']>;
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  preQueryString?: InputMaybe<Scalars['String']>;
  queryString: Scalars['String'];
  sortFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type MutationSearchHoldingsArgs = {
  filterNames: Array<Scalars['String']>;
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  preQueryString?: InputMaybe<Scalars['String']>;
  queryString: Scalars['String'];
  sortFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type MutationSearchOffersArgs = {
  filterNames: Array<Scalars['String']>;
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  preQueryString?: InputMaybe<Scalars['String']>;
  queryString: Scalars['String'];
  sortFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type MutationSearchWatchlistArgs = {
  filterNames: Array<Scalars['String']>;
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  preQueryString?: InputMaybe<Scalars['String']>;
  queryString: Scalars['String'];
  sortFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type MutationSearchWineVintagesArgs = {
  filterNames: Array<Scalars['String']>;
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  preQueryString?: InputMaybe<Scalars['String']>;
  queryString: Scalars['String'];
  sortFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type MutationSearchWineVintagesFacetsArgs = {
  filterNames: Array<Scalars['String']>;
  preQueryString?: InputMaybe<Scalars['String']>;
  queryString: Scalars['String'];
};


export type MutationSetCustomReferralCodeArgs = {
  customCode: Scalars['String'];
};


export type MutationSettleInvoicesArgs = {
  input: SettleInvoicesInput;
};


export type MutationShareWatchlistAssetsArgs = {
  input: ShareWatchlistAssetsInput;
};


export type MutationShareWatchlistGroupArgs = {
  email: Scalars['String'];
  groupId: Scalars['Int'];
};


export type MutationTransferInventoryOutArgs = {
  assetUnitIds: Array<Scalars['String']>;
};


export type MutationTransferInventoryOutV2Args = {
  transferInventoryOutV2Input: TransferInventoryOutV2Input;
};


export type MutationUnlockStocksArgs = {
  unlockStocksInput: UnlockStocksInput;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['String'];
  payload: Scalars['JSON'];
};


export type MutationUpdateCategoryTypeArgs = {
  id: Scalars['String'];
  payload: Scalars['JSON'];
};


export type MutationUpdateCultxPreferencesArgs = {
  input: UpdateCultxPreferencesInput;
};


export type MutationUpdateDefaultMitCardArgs = {
  defaultMitCard: DefaultMitCardInput;
};


export type MutationUpdateMitConsentArgs = {
  updateMitConsentInput: UpdateMitConsentInput;
};


export type MutationUpdateNotificationArgs = {
  id: Scalars['String'];
  payload: Scalars['JSON'];
};


export type MutationUpdatePaymentDetailArgs = {
  input: UpdatePaymentDetailInput;
};


export type MutationUpdateStripeRecurringPaymentArgs = {
  request: UpdateStripeRecurringPaymentInput;
};


export type MutationUpdateUserQuickSearchArgs = {
  input: Array<UpdateUserQuickSearchInput>;
};


export type MutationWithdrawConfirmationArgs = {
  input: WithdrawConfirmationInput;
};


export type MutationZellarClientAddAddressArgs = {
  address: AddressInput;
};


export type MutationZellarClientDeleteAddressArgs = {
  addressId: Scalars['String'];
};


export type MutationZellarClientUpdateAddressArgs = {
  address: AddressInput;
  addressId: Scalars['String'];
};

export type MyTrades = {
  __typename?: 'MyTrades';
  asset: Asset;
  assetId: Scalars['Int'];
  bid: Bid;
  bookingEngineId: Scalars['String'];
  id: Scalars['String'];
  offer: Offer;
  price: Scalars['Float'];
  purchasePrice?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  size: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  totalPrice: Scalars['Float'];
  tradeTime: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  assetId?: Maybe<Scalars['Int']>;
  body: Scalars['String'];
  category: Scalars['String'];
  createdDateTime: Scalars['String'];
  dateTime: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  subject: Scalars['String'];
  summary: Scalars['String'];
  type: Scalars['String'];
  updatedDateTime?: Maybe<Scalars['String']>;
};

export type NotificationCategory = {
  __typename?: 'NotificationCategory';
  channels?: Maybe<Channels>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  types?: Maybe<Array<NotificationCategoryType>>;
};

export type NotificationCategoryType = {
  __typename?: 'NotificationCategoryType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type NotificationCategoryTypeInput = {
  description: Scalars['String'];
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type NotificationRequest = {
  __typename?: 'NotificationRequest';
  assetId?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  createdDateTime: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  pushData?: Maybe<Scalars['JSON']>;
  summary: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['String']>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  results: Array<Notification>;
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
  unreadCount: Scalars['Int'];
};

export type NotificationSettingsResponse = {
  __typename?: 'NotificationSettingsResponse';
  categories: Array<NotificationCategory>;
};

export type Offer = {
  __typename?: 'Offer';
  assetId: Scalars['Int'];
  buyerCost?: Maybe<Scalars['Float']>;
  clientOrderId: Scalars['String'];
  direction: Scalars['Int'];
  filledTime: Scalars['String'];
  filledType: TaskStateEnumType;
  id: Scalars['String'];
  price: Scalars['Int'];
  purchasePrice?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  submittedTimeUtc: Scalars['String'];
  transactionFee?: Maybe<Scalars['Float']>;
  transactionFeePercent?: Maybe<Scalars['Float']>;
  userId: Scalars['String'];
};

export type OffersResponse = {
  __typename?: 'OffersResponse';
  offers: Array<WineSearcherOffer>;
};

export type OffersResult = {
  __typename?: 'OffersResult';
  appellation?: Maybe<Scalars['String']>;
  assetId: Scalars['Int'];
  calculatedMarketData: CalculatedMarketData;
  date: Scalars['String'];
  docId: Scalars['String'];
  expiryDate: Scalars['String'];
  myOffer: Scalars['Float'];
  offerStatus: Scalars['String'];
  region: Scalars['String'];
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int'];
  unitSize: Scalars['String'];
  vintage: Scalars['Int'];
  wineName: Scalars['String'];
};

export type OmsGetMyOrdersV2Response = {
  __typename?: 'OmsGetMyOrdersV2Response';
  count: Scalars['Int'];
  results: Array<BookedOrder>;
};

export type OnboardingStatusResponse = {
  __typename?: 'OnboardingStatusResponse';
  hasSetBusinessAccount: Scalars['Boolean'];
  hasSetCreditAgreement: Scalars['Boolean'];
  hasSetWineRecommendation: Scalars['Boolean'];
};

export type OnboardingStepStatusResponse = {
  __typename?: 'OnboardingStepStatusResponse';
  completedAt?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  stepId?: Maybe<Scalars['Int']>;
  stepName?: Maybe<Scalars['String']>;
  stepOrder?: Maybe<Scalars['Int']>;
};

export enum OnboardingTypeEnums {
  CultX_TradeAccount = 'CultX_TradeAccount',
  CultX_Whale = 'CultX_Whale'
}

export enum OperationType {
  Adjustment = 'Adjustment',
  Fresh = 'Fresh',
  Purchase = 'Purchase',
  Refund = 'Refund',
  Sale = 'Sale'
}

export type Order = {
  __typename?: 'Order';
  asset: CosmosAsset;
  cancelled?: Maybe<Scalars['String']>;
  direction: Scalars['String'];
  executableWindow?: Maybe<CosmosExecutableWindow>;
  id: Scalars['String'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  status: Scalars['String'];
  userId: Scalars['String'];
};

export type OrderBook = {
  __typename?: 'OrderBook';
  assetId: Scalars['Int'];
  bids?: Maybe<Array<Maybe<OrderBookdBidOffer>>>;
  lastTradeDate?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<OrderBookdBidOffer>>>;
};

export type OrderBookdBidOffer = {
  __typename?: 'OrderBookdBidOffer';
  direction: Scalars['Int'];
  orderId: Scalars['String'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  quantityOutstanding: Scalars['Int'];
};

export enum OrderFillType {
  _1 = '_1',
  _2 = '_2'
}

export type OrderSpread = {
  __typename?: 'OrderSpread';
  highestBid?: Maybe<SpreadOrder>;
  lowestOffer?: Maybe<SpreadOrder>;
  percentageDifference?: Maybe<Scalars['Float']>;
};

export type OrderStatusResponse = {
  __typename?: 'OrderStatusResponse';
  assetId: Scalars['Int'];
  cancelled: Scalars['Boolean'];
  clientOrderId: Scalars['String'];
  id: Scalars['ID'];
  outstandingQuantity: Scalars['Int'];
  status: Scalars['String'];
};

export type OriginCountryResult = {
  __typename?: 'OriginCountryResult';
  assetId?: Maybe<Scalars['Int']>;
  lwin18?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
};

export type PartnersAuthLoginInput = {
  clientId?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  loginByApp?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type PartnersAuthLoginResponse = {
  __typename?: 'PartnersAuthLoginResponse';
  accessToken: Scalars['String'];
  idToken: Scalars['String'];
  refreshToken: Scalars['String'];
  tokenType: Scalars['String'];
  userToken: Scalars['String'];
};

export type PartnersAuthRefreshAccessTokenInput = {
  clientId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

export type PartnersAuthRefreshAccessTokenResponse = {
  __typename?: 'PartnersAuthRefreshAccessTokenResponse';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  userToken: Scalars['String'];
};

export type PaymentDetailResponse = {
  __typename?: 'PaymentDetailResponse';
  accountNumber?: Maybe<Scalars['String']>;
  bicOrSwift?: Maybe<Scalars['String']>;
  createdDateTime: Scalars['String'];
  iban?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  nameOnAccount?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['String'];
};

export enum PaymentMethod {
  BankTransfer = 'BankTransfer',
  Card = 'Card'
}

export type PaymentResourceInput = {
  amount: Scalars['Float'];
  returnUri: Scalars['String'];
};

export type PaymentSessionInput = {
  accountHolderId?: InputMaybe<Scalars['Int']>;
  amount: Scalars['Float'];
  amountGbp?: InputMaybe<Scalars['Float']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  defaultMitFlag?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  failureUrl: Scalars['String'];
  instrumentId?: InputMaybe<Scalars['String']>;
  mitConsentedFlag?: InputMaybe<Scalars['Boolean']>;
  operationType?: InputMaybe<Scalars['String']>;
  portfolioId?: InputMaybe<Scalars['Int']>;
  referenceId?: InputMaybe<Scalars['String']>;
  storeCardFlag?: InputMaybe<Scalars['Boolean']>;
  successUrl: Scalars['String'];
  transactionType?: InputMaybe<Scalars['String']>;
};

export type PaymentSessionResponse = {
  __typename?: 'PaymentSessionResponse';
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paymentSessionSecret?: Maybe<Scalars['String']>;
  paymentSessionToken: Scalars['String'];
  referenceId?: Maybe<Scalars['String']>;
};

export type PendingReferralCode = {
  __typename?: 'PendingReferralCode';
  code?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['String']>;
  expiredDateTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  refereeAmount?: Maybe<Scalars['Float']>;
  referreeId?: Maybe<Scalars['String']>;
  referrerAmount?: Maybe<Scalars['Float']>;
  referrerId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supersededDateTime?: Maybe<Scalars['String']>;
  usedDateTime?: Maybe<Scalars['String']>;
};

export type PortaBalanceAndInvestmentValues = {
  __typename?: 'PortaBalanceAndInvestmentValues';
  balances?: Maybe<Array<Maybe<PortalCashBalanceItem>>>;
  todayInvestment: Scalars['Float'];
};

export type PortalAnnualisedReturnItem = {
  __typename?: 'PortalAnnualisedReturnItem';
  date: Scalars['String'];
  value: Scalars['Float'];
};

export type PortalAuthRegisterUserInput = {
  emailAddress: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  platform?: InputMaybe<Scalars['String']>;
  registeredByApp: Scalars['String'];
  residenceCountry?: InputMaybe<Scalars['String']>;
};

export type PortalBuyWineRequestInput = {
  holdingId: Scalars['String'];
  purchasePrice: Scalars['Float'];
  qty: Scalars['Int'];
  requestPrice: Scalars['Float'];
};

export type PortalCashBalanceItem = {
  __typename?: 'PortalCashBalanceItem';
  balance: Scalars['Float'];
  portfolioId?: Maybe<Scalars['Int']>;
  portfolioName: Scalars['String'];
};

export type PortalClientPreferencesResponse = {
  __typename?: 'PortalClientPreferencesResponse';
  annualManagementFeePayType?: Maybe<Scalars['String']>;
  autoTrade?: Maybe<Scalars['Boolean']>;
  bankTransferChaseEmailCount: Scalars['Int'];
  currency: Scalars['String'];
  firstLoginDate?: Maybe<Scalars['String']>;
  historicManagementFeePayType?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  managementFeePayment?: Maybe<Scalars['String']>;
};

export type PortalCurrentHoldingItem = {
  __typename?: 'PortalCurrentHoldingItem';
  changedPct: Scalars['Float'];
  costPerUnit: Scalars['Float'];
  costWithMgmtFeePerUnit: Scalars['Float'];
  cultWinesAllocationRegion: Scalars['String'];
  dealCCY?: Maybe<Scalars['String']>;
  dealDate: Scalars['String'];
  dealRef: Scalars['String'];
  historicMarketPrices?: Maybe<Array<Maybe<HistoricMarketPriceItem>>>;
  id: Scalars['String'];
  imageFileName?: Maybe<Scalars['String']>;
  lwin11: Scalars['String'];
  lwin18: Scalars['String'];
  mgmtFeePerUnit: Scalars['Float'];
  netPosition: Scalars['Float'];
  netPositionPerUnit: Scalars['Float'];
  portfolioId: Scalars['Int'];
  priceForSale?: Maybe<Scalars['Float']>;
  profitAndLoss: Scalars['Float'];
  profitAndLossPerUnit: Scalars['Float'];
  qty: Scalars['Int'];
  qtyForSale: Scalars['Int'];
  region: Scalars['String'];
  totalCost: Scalars['Float'];
  totalCostWithMgmtFee: Scalars['Float'];
  totalMgmtFee: Scalars['Float'];
  totalValue: Scalars['Float'];
  unit: Scalars['String'];
  unitCount: Scalars['Int'];
  valuePerBottle: Scalars['Float'];
  valuePerUnit: Scalars['Float'];
  vintage?: Maybe<Scalars['Int']>;
  wineName: Scalars['String'];
};

export type PortalDeliverWineRequestInput = {
  address1: Scalars['String'];
  address2: Scalars['String'];
  address3: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  holdingId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  qty: Scalars['Int'];
  rotationNumber?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type PortalEmailValidationResponse = {
  __typename?: 'PortalEmailValidationResponse';
  status?: Maybe<PortalEmailValidationStatus>;
};

export enum PortalEmailValidationStatus {
  Invalid = 'Invalid',
  Registered = 'Registered',
  Valid = 'Valid'
}

export type PortalEstimateManagementFeeResponse = {
  __typename?: 'PortalEstimateManagementFeeResponse';
  annualFeeAmount: Scalars['Float'];
  discountPct: Scalars['Float'];
  discountedAnnualFeeAmount: Scalars['Float'];
  monthlyFeeAmount: Scalars['Float'];
};

export type PortalExternalHoldingItem = {
  __typename?: 'PortalExternalHoldingItem';
  cashOffer: Scalars['Float'];
  changedPct?: Maybe<Scalars['Float']>;
  costPerUnit?: Maybe<Scalars['Float']>;
  createdDate: Scalars['String'];
  cultWinesAllocationRegion: Scalars['String'];
  imageFileName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  lwin11: Scalars['String'];
  lwin18: Scalars['String'];
  netPosition?: Maybe<Scalars['Float']>;
  qty: Scalars['Int'];
  region: Scalars['String'];
  totalCost?: Maybe<Scalars['Float']>;
  totalValue: Scalars['Float'];
  unit: Scalars['String'];
  unitCount: Scalars['Int'];
  valuePerUnit: Scalars['Float'];
  vintage?: Maybe<Scalars['Int']>;
  wineName: Scalars['String'];
};

export type PortalHoldingDetails = {
  __typename?: 'PortalHoldingDetails';
  changedPct: Scalars['Float'];
  costPerUnit: Scalars['Float'];
  costWithMgmtFeePerUnit: Scalars['Float'];
  cultWinesAllocationRegion: Scalars['String'];
  dealCCY?: Maybe<Scalars['String']>;
  dealDate: Scalars['String'];
  dealRef: Scalars['String'];
  historicMarketPrices?: Maybe<Array<Maybe<HistoricMarketPriceItem>>>;
  holdingStocks?: Maybe<Array<Maybe<PortalHoldingStockItem>>>;
  id: Scalars['String'];
  imageFileName?: Maybe<Scalars['String']>;
  lwin11: Scalars['String'];
  lwin18: Scalars['String'];
  mgmtFeePerUnit: Scalars['Float'];
  netPosition: Scalars['Float'];
  netPositionPerUnit: Scalars['Float'];
  portfolioId: Scalars['Int'];
  priceForSale?: Maybe<Scalars['Float']>;
  profitAndLoss: Scalars['Float'];
  profitAndLossPerUnit: Scalars['Float'];
  qty: Scalars['Int'];
  qtyForSale: Scalars['Int'];
  region: Scalars['String'];
  totalCost: Scalars['Float'];
  totalCostWithMgmtFee: Scalars['Float'];
  totalMgmtFee: Scalars['Float'];
  totalValue: Scalars['Float'];
  unit: Scalars['String'];
  unitCount: Scalars['Int'];
  valuePerBottle: Scalars['Float'];
  valuePerUnit: Scalars['Float'];
  vintage?: Maybe<Scalars['Int']>;
  wineName: Scalars['String'];
};

export type PortalHoldingStockItem = {
  __typename?: 'PortalHoldingStockItem';
  location?: Maybe<Scalars['String']>;
  rotationNumber: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type PortalInvestNowRequestInput = {
  numberOfUnits: Scalars['Int'];
  offerExpiryDate: Scalars['String'];
  offerPrice: Scalars['Float'];
  offerSubTitle: Scalars['String'];
  offerTitle: Scalars['String'];
  totalPrice: Scalars['Float'];
};

export type PortalManagementFeeResponse = {
  __typename?: 'PortalManagementFeeResponse';
  accountHolderName: Scalars['String'];
  appliedPct?: Maybe<Scalars['Float']>;
  clientName: Scalars['String'];
  feeAmount: Scalars['Float'];
  feeType: Scalars['String'];
  id: Scalars['String'];
  invoiceDate?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['Int']>;
  offsetValue?: Maybe<Scalars['Float']>;
  portfolioValue?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  valuationDate: Scalars['String'];
  vintradeAccountHolderId: Scalars['Int'];
  vintradeClientId: Scalars['String'];
};

export type PortalMyCellarItem = {
  __typename?: 'PortalMyCellarItem';
  cultWinesAllocationRegion: Scalars['String'];
  dealCCY?: Maybe<Scalars['String']>;
  dealDate: Scalars['String'];
  dealRef: Scalars['String'];
  holdingId: Scalars['String'];
  imageFileName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  lwin11: Scalars['String'];
  lwin18: Scalars['String'];
  portfolioId: Scalars['Int'];
  qty: Scalars['Int'];
  region: Scalars['String'];
  rotationNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stockId?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
  unitCount: Scalars['Int'];
  vintage?: Maybe<Scalars['Int']>;
  wineName: Scalars['String'];
};

export type PortalMyCellarWineDetailsItem = {
  __typename?: 'PortalMyCellarWineDetailsItem';
  changedPct: Scalars['Float'];
  costPerUnit: Scalars['Float'];
  costWithMgmtFeePerUnit: Scalars['Float'];
  cultWinesAllocationRegion: Scalars['String'];
  dealCCY?: Maybe<Scalars['String']>;
  dealDate: Scalars['String'];
  dealRef: Scalars['String'];
  historicMarketPrices?: Maybe<Array<Maybe<HistoricMarketPriceItem>>>;
  id: Scalars['String'];
  imageFileName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  lwin11: Scalars['String'];
  lwin18: Scalars['String'];
  mgmtFeePerUnit: Scalars['Float'];
  netPosition: Scalars['Float'];
  netPositionPerUnit: Scalars['Float'];
  portfolioId: Scalars['Int'];
  priceForSale?: Maybe<Scalars['Float']>;
  profitAndLoss: Scalars['Float'];
  profitAndLossPerUnit: Scalars['Float'];
  qty: Scalars['Int'];
  qtyForSale: Scalars['Int'];
  region: Scalars['String'];
  rotationNumber: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  stockId: Scalars['String'];
  totalCost: Scalars['Float'];
  totalCostWithMgmtFee: Scalars['Float'];
  totalMgmtFee: Scalars['Float'];
  totalValue: Scalars['Float'];
  unit: Scalars['String'];
  unitCount: Scalars['Int'];
  valuePerBottle: Scalars['Float'];
  valuePerUnit: Scalars['Float'];
  vintage?: Maybe<Scalars['Int']>;
  wineName: Scalars['String'];
};

export type PortalOutstandingManagementFeeResponse = {
  __typename?: 'PortalOutstandingManagementFeeResponse';
  partialOutstandingFeesAmount?: Maybe<Scalars['Float']>;
  totalOutstandingFeesAmount?: Maybe<Scalars['Float']>;
};

export type PortalPerformanceHistoricItem = {
  __typename?: 'PortalPerformanceHistoricItem';
  currentHoldings: Scalars['Float'];
  date: Scalars['String'];
  netContributions: Scalars['Float'];
};

export type PortalPortfolioAnnualisedReturn = {
  __typename?: 'PortalPortfolioAnnualisedReturn';
  monthly?: Maybe<Array<PortalAnnualisedReturnItem>>;
  years?: Maybe<Array<PortalAnnualisedReturnItem>>;
};

export type PortalPortfolioCurrentAllocationItem = {
  __typename?: 'PortalPortfolioCurrentAllocationItem';
  StrategicAllocation: Scalars['Float'];
  currentAllocation: Scalars['Float'];
  regionName: Scalars['String'];
  tacticalAllocation: Scalars['Float'];
};

export type PortalPortfolioCurrentAllocationResponse = {
  __typename?: 'PortalPortfolioCurrentAllocationResponse';
  portalPortfolioCurrentAllocation?: Maybe<Array<Maybe<PortalPortfolioCurrentAllocationItem>>>;
  portalRegionPerformances: Array<PortalRegionPerformanceItem>;
};

export type PortalPortfolioPerformanceItem = {
  __typename?: 'PortalPortfolioPerformanceItem';
  balance: Scalars['Float'];
  balancePending: Scalars['Float'];
  capitalInvested: Scalars['Float'];
  currentFeeModel: Scalars['Boolean'];
  currentHoldings: Scalars['Float'];
  feeModel?: Maybe<Scalars['String']>;
  firstDealDate?: Maybe<Scalars['String']>;
  netContributions: Scalars['Float'];
  netPosition: Scalars['Float'];
  netPositionPct: Scalars['Float'];
  netProceedsFromSales: Scalars['Float'];
  portfolioId?: Maybe<Scalars['Int']>;
  portfolioName: Scalars['String'];
  profitAndLoss: Scalars['Float'];
  profitAndLossPct: Scalars['Float'];
  totalMgmtFee: Scalars['Float'];
  totalRefunds: Scalars['Float'];
};

export type PortalProcessWineResponse = {
  __typename?: 'PortalProcessWineResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type PortalRegionPerformanceItem = {
  __typename?: 'PortalRegionPerformanceItem';
  currentHoldings: Scalars['Float'];
  netPosition: Scalars['Float'];
  netPositionPct: Scalars['Float'];
  regionName: Scalars['String'];
  totalPurchasePrice: Scalars['Float'];
};

export type PortalSellWineRequestInput = {
  holdingId: Scalars['String'];
  marketPrice: Scalars['Float'];
  qty: Scalars['Int'];
  reasonForSale: Scalars['String'];
  reservePrice: Scalars['Float'];
};

export type PortalSoldHoldingItem = {
  __typename?: 'PortalSoldHoldingItem';
  changedPct: Scalars['Float'];
  costPerUnit: Scalars['Float'];
  costWithMgmtFeePerUnit: Scalars['Float'];
  cultWinesAllocationRegion: Scalars['String'];
  dealDate: Scalars['String'];
  dealRef: Scalars['String'];
  imageFileName?: Maybe<Scalars['String']>;
  lwin11: Scalars['String'];
  lwin18: Scalars['String'];
  mgmtFeePerUnit: Scalars['Float'];
  netPosition: Scalars['Float'];
  netPositionPerUnit: Scalars['Float'];
  portfolioId: Scalars['Int'];
  profitAndLoss: Scalars['Float'];
  profitAndLossPerUnit: Scalars['Float'];
  qtySold: Scalars['Int'];
  region: Scalars['String'];
  soldDate: Scalars['String'];
  soldPricePerUnit: Scalars['Float'];
  status: Scalars['String'];
  totalCost: Scalars['Float'];
  totalCostWithMgmtFee: Scalars['Float'];
  totalMgmtFee: Scalars['Float'];
  totalValue: Scalars['Float'];
  unit: Scalars['String'];
  unitCount: Scalars['Int'];
  vintage?: Maybe<Scalars['Int']>;
  wineName: Scalars['String'];
};

export type PortfolioHighlights = {
  __typename?: 'PortfolioHighlights';
  estimatedMonthlyStorage: Scalars['Float'];
  nextStorageChargeDate?: Maybe<Scalars['String']>;
  portfolioValue: Scalars['Float'];
  simpleReturn: Scalars['Float'];
  totalContributions: Scalars['Float'];
  totalPurchasePrice: Scalars['Float'];
};

export type Preferences = {
  __typename?: 'Preferences';
  createdDateTime?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deliveryCountry?: Maybe<Scalars['String']>;
  deliveryRegion?: Maybe<Scalars['String']>;
  purchaseDeliveryType?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['String']>;
};

export type Producer = {
  __typename?: 'Producer';
  id: Scalars['Int'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ProductAiExplainerResponse = {
  __typename?: 'ProductAIExplainerResponse';
  explainer?: Maybe<Scalars['String']>;
  lwin11?: Maybe<Scalars['String']>;
};

export type ProductScoresResponse = {
  __typename?: 'ProductScoresResponse';
  fairValueScore: Scalars['Float'];
  foundScore: Scalars['Boolean'];
  grade: Scalars['Int'];
  liquidityScore: Scalars['Float'];
  lwin11: Scalars['ID'];
  normalizedCriticScore: Scalars['Float'];
  performanceScore: Scalars['Float'];
  totalScore: Scalars['Float'];
  vintageScore: Scalars['Float'];
};

export type ProfitAndLossHistory_Gql = {
  __typename?: 'ProfitAndLossHistory_GQL';
  date: Scalars['String'];
  profitAndLoss: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  accountHolds: AccountHold;
  assetFeeConfig: AssetFeeConfig;
  assetLastPurchase: AssetLastPurchaseResponse;
  authUser: AuthUser;
  authUserJwt: AuthUserJwtResponse;
  /**
   * Returns user's available balance against which he can make bids
   *
   * Equivalent to GET /api/AvailableBalance/AvailableBalance
   */
  availableBalance: Scalars['Float'];
  availableWithdrawalAmount?: Maybe<FinancialAvailableWithdrawalAmount>;
  /** Photo summary for the Buy Now right-rail signal on the product page. */
  buyNowPhotoSummary?: Maybe<BuyNowPhotoSummary>;
  calculatedMarketData: CalculatedMarketData;
  cancelledBids: Array<CancelledBidsResponse>;
  costBreakDown?: Maybe<CostBreakDownResult>;
  creditLimitAndBalance: CreditLimitAndBalanceResponse;
  customerCards?: Maybe<Array<StripeCardItem>>;
  deliveryCostBreakDown: DeliveryCostBreakDownResponse;
  deliveryRequests: Array<DeliveryRequest>;
  deliveryTransaction?: Maybe<DeliveryTransactionResponse>;
  downladInvoicePdf: InvoicePdfResponse;
  externalPortfolioUserAssetInstances: Array<ExternalPortfolioInstance>;
  externalPortfolioUserAssets: Array<ExternalPortfolioAsset>;
  externalPortfolioUserHasAsset: Scalars['Boolean'];
  financeCurrentBalance?: Maybe<FinancialOperationCurrentBalance>;
  financeGetMonthlyWiseFlowByMonthRange?: Maybe<FinancialOperationMonthWiseFlow>;
  financeGetRecent: Array<FinancialRecentOperation>;
  financeGetStorageAndInsurance: Array<StorageAndInsuranceResponse>;
  financeTotalCapitalInvested?: Maybe<FinancialOperationCapitalInvestment>;
  generateReferralCode: GeneratedReferralCodeResult;
  getActiveMarketsFilters?: Maybe<ActiveMarketFiltersResult>;
  getBankDetails: Array<Maybe<BankDetails>>;
  /** Get HubSpot Customer */
  getCustomer: HubSpotCustomer;
  getDistinctProducers: Array<Maybe<GetDistinctProducersResponse>>;
  getDistinctRegions: Array<Maybe<GetDistinctRegionsResponse>>;
  /** Get the latest exchange rate for a single currency */
  getExchangeRate?: Maybe<ExchangeRate>;
  /** Get the latest exchange rates for multiple currencies */
  getExchangeRates: Array<ExchangeRate>;
  getGeneratedPortfolio: GeneratedPortfolioResponse;
  getGeneratedWineRecommendations: GeneratedPortfolioResponse;
  getInvoiceTransactionStatuses: InvoiceTransactionStatusResponse;
  getOnboardingStepStatus: Array<Maybe<OnboardingStepStatusResponse>>;
  getPendingReferralCode?: Maybe<PendingReferralCode>;
  getPreferences?: Maybe<Preferences>;
  getReferralStatus: Array<ReferralCode>;
  getRegionsFilters?: Maybe<Array<Maybe<RegionFilter>>>;
  getRewardConfig?: Maybe<Array<Maybe<RewardConfigResult>>>;
  getSubRegionsFilters?: Maybe<Array<Maybe<RegionFilter>>>;
  getSupportMessageByUserId?: Maybe<IGetSupportMessageByUserId>;
  getTransactionHistory?: Maybe<GetTransactionHistoryResponse>;
  getTransactionHistoryLogout?: Maybe<GetTransactionHistoryResponse>;
  getWineMatrixFilters?: Maybe<WineMatrixFiltersResult>;
  getWineMatrixVintageRange?: Maybe<WineMatrixVintageRangeResult>;
  historicalMarketValue: Array<HistoricalMarketData>;
  historicalMarketValueChange: Array<HistoricalMarketDataChange>;
  holdingGetUserHoldingsMarketPrice: Scalars['Float'];
  holdingsCurrent: Array<UserHolding>;
  imsRegionSummary: Array<ImsRegionSummary>;
  inventoriesByDatetimeRange: Scalars['JSON'];
  invoiceItems?: Maybe<InvoiceItemsResponse>;
  invoices: Array<InvoicesResponse>;
  isAssetExistInAnyHoldings: Scalars['Boolean'];
  isEmailVerified: Scalars['Boolean'];
  isRegistered: Scalars['Boolean'];
  isUserHoldingHasAsset: Scalars['Boolean'];
  liveBidValidation: LiveBidValidationResponse;
  /** Lot grouping for a single order-book cell, given the asset, price, and case count. */
  lotPickerData?: Maybe<LotPickerData>;
  /** Get market depending on the parameters */
  marketData: MarketData;
  miscellaneous?: Maybe<MiscellaneousType>;
  /**
   * Returns a list of all the trades for a specific asset
   *
   * Equivalent to GET /api/OrderBooking/AllTradesByAsset
   */
  omsAllTradesByAsset: Array<Trade>;
  /**
   * Returns a list of users orders
   * Equivalent to GET /api/OrderBooking/MyOrders
   */
  omsGetMyOrders: Array<BookedOrder>;
  omsGetMyOrdersV2: OmsGetMyOrdersV2Response;
  /**
   * Returns a list of users trades
   * Equivalent to GET /api/OrderBooking/MyTrades
   */
  omsGetMyTrades: Array<MyTrades>;
  /** Returns highest bid and lowest offer for given asset id */
  omsSpreadByAssetId: OrderSpread;
  onboardingStatus: OnboardingStatusResponse;
  /**
   * Returns a list of all the booked orders for a specific Id
   *
   * Equivalent to GET /api/OrderBooking/AllOrdersByAssetId
   */
  openOrders: Array<BookedOrder>;
  orderStatus: Array<OrderStatusResponse>;
  originCountryByLwin18: Array<OriginCountryResult>;
  paymentGetCardDetails?: Maybe<Array<CardDetailResponse>>;
  paymentReferenceNumber?: Maybe<Scalars['String']>;
  /** Portal client cash balance */
  portalCashBalance: PortaBalanceAndInvestmentValues;
  portalClientPreferences?: Maybe<PortalClientPreferencesResponse>;
  /** Portal portfolio current holdings */
  portalCurrentHoldings: Array<PortalCurrentHoldingItem>;
  portalDocument?: Maybe<Scalars['JSON']>;
  /** Get Customer Estimate Management Fees */
  portalEstimateManagementFee: PortalEstimateManagementFeeResponse;
  /** Portal portfolio external holdings */
  portalExternalHoldings?: Maybe<Array<PortalExternalHoldingItem>>;
  /** Portal portfolio holding details */
  portalHoldingDetails?: Maybe<PortalHoldingDetails>;
  /** Get Customer Management Fees */
  portalManagementFees: Array<Maybe<PortalManagementFeeResponse>>;
  /** Portal my cellar */
  portalMyCellar?: Maybe<Array<PortalMyCellarItem>>;
  /** Portal my cellar wine detail */
  portalMyCellarWineDetails?: Maybe<PortalMyCellarWineDetailsItem>;
  portalNotifications: NotificationResponse;
  /** Get Customer Outstanding Management Fees Amount */
  portalOutstandingManagementFeeAmount: PortalOutstandingManagementFeeResponse;
  /** Portal client annualised returns */
  portalPortfolioAnnualisedReturn?: Maybe<PortalPortfolioAnnualisedReturn>;
  /** Portal client's PortfolioBalance */
  portalPortfolioBalance?: Maybe<Array<PortalPortfolioPerformanceItem>>;
  /** Portal portfolio current allocation */
  portalPortfolioCurrentAllocation: PortalPortfolioCurrentAllocationResponse;
  /** Portal portfolio performance over time */
  portalPortfolioPerformanceOverTime: Array<PortalPerformanceHistoricItem>;
  /** Portal portfolio sold holdings */
  portalSoldHoldings?: Maybe<Array<PortalSoldHoldingItem>>;
  productAIExplainer: ProductAiExplainerResponse;
  /**
   * Get a asset by its Id
   *
   * Equivalent to GET /Product/Asset/:id
   */
  productAsset?: Maybe<Asset>;
  /** Get asset instances by assetId */
  productAssetInstances: Array<AssetInstance>;
  /**
   * Get assets by query parameters
   *
   * Equivalent to GET /Product/Assets
   */
  productAssets: Array<Asset>;
  productScores: ProductScoresResponse;
  /**
   * Get wine
   *
   * Equivalent to GET /Product/Wines/:id
   */
  productWine: Wine;
  /**
   * Get wine vintage by wineVintageId
   *
   * Equivalent to GET /Product/WineVintages/:id
   */
  productWineVintage?: Maybe<WineVintage>;
  /**
   * Get wine vintage by query parameters
   *
   * Equivalent to GET /Product/WineVintages
   */
  productWineVintages: Array<WineVintage>;
  /**
   * Get wines
   *
   * Equivalent to GET /Product/Wines
   */
  productWines: Array<Wine>;
  reCaptchaTokenValidation: Scalars['Boolean'];
  realisedGains: Scalars['Float'];
  receivedBids: ReceivedBidsResponse;
  recurringPaymentPrices?: Maybe<Array<RecurringPaymentPriceItem>>;
  recurringPayments?: Maybe<Array<RecurringPaymentResponse>>;
  redeemStatus: Array<RedeemStatusEntry>;
  relatedVintages?: Maybe<RelatedVintagesResponse>;
  rewardBalance: RewardBalanceResult;
  rewardSetting: RewardSettingResult;
  searchActiveMarkets: ActiveMarketResult;
  searchRecommendations: Array<Maybe<SearchRecommendationResults>>;
  searchWineMatrix: WineMatrixResult;
  sendSupportMessage?: Maybe<ISendSupportMessage>;
  stockStatus: StockStatusResponse;
  storageAndInsuranceDetails: Array<StorageAndInsuranceDetail>;
  suggestActiveMarketWines: Array<SuggestActiveMarketWinesResults>;
  /**
   * Suggest wine vintages from Elastic Search
   *
   * Equivalent to GET /Search/SuggestWineVintages with indexName 'wine-vintage'
   */
  suggestWineVintages: SuggestWineVintagesResult;
  /**
   * Suggest wines from Elastic Search
   *
   * Equivalent to GET /Search/SuggestWines with indexName 'wine'
   */
  suggestWines: SuggestWinesResult;
  unrealisedGains: Scalars['Float'];
  userExists: Scalars['Boolean'];
  userExternalPortfolioTotalValue: Scalars['Float'];
  userHasExternalPortfolio: Scalars['Boolean'];
  /**
   * Get if user has a watchList
   *
   * Equivalent to GET /ZellarWatchList/IsUserHasWatchList
   */
  userHasWatchList: Scalars['Boolean'];
  userLocationInfo: UserLocationInfo;
  /**
   * Get notifications settings of a user
   *
   * Equivalent to GET /UserNotificationSettings
   */
  userNotificationSettings: NotificationSettingsResponse;
  /**
   * Get notifications of user
   *
   * Equivalent to GET /UserNotifications
   */
  userNotifications: NotificationResponse;
  userPortfolioHighlights: PortfolioHighlights;
  userPrimaryGoal?: Maybe<Scalars['String']>;
  /** Get user's saved quick searches (filter preferences) */
  userQuickSearches: Array<UserQuickSearch>;
  userSettings?: Maybe<UserSettings>;
  validReferralCode: ValidReferralCodeResult;
  validatePortalEmail: PortalEmailValidationResponse;
  validatePostCode?: Maybe<ValidatePostCodeResult>;
  /**
   * Get watchList of user
   *
   * Equivalent to GET /ZellarWatchList/GetUserWatchList
   */
  watchListItems: Array<WatchListItem>;
  watchlistGroups: Array<WatchlistGroupItem>;
  withdrawPaymentDetails: Array<WithdrawPaymentDetail>;
  zellarClientAddresses: Array<Address>;
  zellarClientGetClient?: Maybe<Client>;
};


export type QueryAssetLastPurchaseArgs = {
  assetId: Scalars['Int'];
};


export type QueryBuyNowPhotoSummaryArgs = {
  assetId: Scalars['Int'];
};


export type QueryCalculatedMarketDataArgs = {
  assetId: Scalars['Int'];
};


export type QueryCostBreakDownArgs = {
  assetId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  dutyTo?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  wineOriginCountry?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerCardsArgs = {
  currency: Scalars['String'];
};


export type QueryDeliveryCostBreakDownArgs = {
  deliveryCostBreakDownInput?: InputMaybe<Array<CostBreakDownInput>>;
};


export type QueryDeliveryTransactionArgs = {
  tradeId: Scalars['String'];
};


export type QueryDownladInvoicePdfArgs = {
  invoiceId?: InputMaybe<Scalars['Int']>;
};


export type QueryExternalPortfolioUserAssetInstancesArgs = {
  assetId: Scalars['Int'];
};


export type QueryExternalPortfolioUserHasAssetArgs = {
  assetId: Scalars['Int'];
};


export type QueryFinanceGetMonthlyWiseFlowByMonthRangeArgs = {
  monthRange: Scalars['Int'];
};


export type QueryGenerateReferralCodeArgs = {
  codeLength?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActiveMarketsFiltersArgs = {
  filters?: InputMaybe<ActiveMarketFilters>;
  from?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  wineName?: InputMaybe<Scalars['String']>;
};


export type QueryGetCustomerArgs = {
  email: Scalars['String'];
};


export type QueryGetDistinctProducersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  producer?: InputMaybe<Scalars['String']>;
};


export type QueryGetDistinctRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
};


export type QueryGetExchangeRateArgs = {
  currency: Scalars['String'];
};


export type QueryGetExchangeRatesArgs = {
  currencies: Array<Scalars['String']>;
};


export type QueryGetGeneratedPortfolioArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type QueryGetGeneratedWineRecommendationsArgs = {
  key: Scalars['String'];
};


export type QueryGetInvoiceTransactionStatusesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOnboardingStepStatusArgs = {
  step?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OnboardingTypeEnums>;
};


export type QueryGetRegionsFiltersArgs = {
  from?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  wineName?: InputMaybe<Scalars['String']>;
};


export type QueryGetSubRegionsFiltersArgs = {
  from?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  wineName?: InputMaybe<Scalars['String']>;
};


export type QueryGetSupportMessageByUserIdArgs = {
  docRef: IGetSupportMessageByUserIdInput;
};


export type QueryGetTransactionHistoryArgs = {
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  isLoggedIn?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  lwin11?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  unitSize?: InputMaybe<Scalars['String']>;
};


export type QueryGetTransactionHistoryLogoutArgs = {
  lwin11?: InputMaybe<Scalars['String']>;
  unitSize?: InputMaybe<Scalars['String']>;
};


export type QueryGetWineMatrixFiltersArgs = {
  filters?: InputMaybe<WineMatrixFilters>;
  from?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  tab: Scalars['String'];
  wineName?: InputMaybe<Scalars['String']>;
};


export type QueryGetWineMatrixVintageRangeArgs = {
  filters?: InputMaybe<WineMatrixFilters>;
  tab?: InputMaybe<Scalars['String']>;
  wineName?: InputMaybe<Scalars['String']>;
};


export type QueryHistoricalMarketValueArgs = {
  assetIds: Array<Scalars['Int']>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
};


export type QueryHistoricalMarketValueChangeArgs = {
  assetIds: Array<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
};


export type QueryHoldingsCurrentArgs = {
  delivered?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryInventoriesByDatetimeRangeArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};


export type QueryInvoiceItemsArgs = {
  invoiceId: Scalars['Int'];
};


export type QueryIsAssetExistInAnyHoldingsArgs = {
  assetId: Scalars['Int'];
};


export type QueryIsEmailVerifiedArgs = {
  userId: Scalars['String'];
};


export type QueryIsRegisteredArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryIsUserHoldingHasAssetArgs = {
  assetId: Scalars['Int'];
};


export type QueryLiveBidValidationArgs = {
  addFees?: InputMaybe<Scalars['Boolean']>;
  newBidPrice: Scalars['Float'];
  prevBidPrice?: InputMaybe<Scalars['Float']>;
};


export type QueryLotPickerDataArgs = {
  assetId: Scalars['Int'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
};


export type QueryMarketDataArgs = {
  assetId: Scalars['Int'];
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};


export type QueryOmsAllTradesByAssetArgs = {
  assetId: Scalars['Int'];
};


export type QueryOmsGetMyOrdersArgs = {
  assetId?: InputMaybe<Scalars['Int']>;
};


export type QueryOmsGetMyOrdersV2Args = {
  assetId?: InputMaybe<Scalars['Int']>;
  clientOrderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderStatus?: InputMaybe<Scalars['String']>;
  saleType?: InputMaybe<Scalars['String']>;
  wineName?: InputMaybe<Scalars['String']>;
};


export type QueryOmsSpreadByAssetIdArgs = {
  assetId: Scalars['Int'];
};


export type QueryOpenOrdersArgs = {
  assetId?: InputMaybe<Scalars['Int']>;
  assetIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryOrderStatusArgs = {
  clientOrderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryOriginCountryByLwin18Args = {
  assetIds?: InputMaybe<Array<Scalars['Int']>>;
  lwin18s?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryPortalDocumentArgs = {
  data?: InputMaybe<Scalars['JSON']>;
  docRef?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
};


export type QueryPortalHoldingDetailsArgs = {
  id: Scalars['String'];
};


export type QueryPortalMyCellarWineDetailsArgs = {
  stockId: Scalars['String'];
};


export type QueryPortalNotificationsArgs = {
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryPortalPortfolioAnnualisedReturnArgs = {
  portfolioId?: InputMaybe<Scalars['Int']>;
};


export type QueryPortalPortfolioPerformanceOverTimeArgs = {
  portfolioId?: InputMaybe<Scalars['Int']>;
};


export type QueryProductAiExplainerArgs = {
  lwin11: Scalars['String'];
};


export type QueryProductAssetArgs = {
  assetId: Scalars['Int'];
};


export type QueryProductAssetInstancesArgs = {
  assetId: Scalars['Int'];
  deliveryRequested?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductAssetsArgs = {
  assetIds?: InputMaybe<Array<Scalars['Int']>>;
  lwin18S?: InputMaybe<Array<Scalars['String']>>;
  wineVintageId?: InputMaybe<Scalars['Int']>;
};


export type QueryProductScoresArgs = {
  lwin11: Scalars['String'];
};


export type QueryProductWineArgs = {
  wineId: Scalars['Int'];
};


export type QueryProductWineVintageArgs = {
  wineVintageId: Scalars['Int'];
};


export type QueryProductWineVintagesArgs = {
  lwin11S?: InputMaybe<Array<Scalars['String']>>;
  wineId?: InputMaybe<Scalars['Int']>;
  wineVintageIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryProductWinesArgs = {
  lwin7?: InputMaybe<Scalars['String']>;
  wineIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryReCaptchaTokenValidationArgs = {
  token: Scalars['String'];
};


export type QueryReceivedBidsArgs = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  clientOrderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  lwin18?: InputMaybe<Scalars['String']>;
  offerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRecurringPaymentPricesArgs = {
  currency: Scalars['String'];
};


export type QueryRedeemStatusArgs = {
  code: Scalars['String'];
};


export type QueryRelatedVintagesArgs = {
  assetId: Scalars['Int'];
  onlyShowLiveMarkets?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QuerySearchActiveMarketsArgs = {
  filters?: InputMaybe<ActiveMarketFilters>;
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  wineName?: InputMaybe<Scalars['String']>;
};


export type QuerySearchRecommendationsArgs = {
  recSize?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchWineMatrixArgs = {
  filters?: InputMaybe<WineMatrixFilters>;
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  tab: Scalars['String'];
  wineName?: InputMaybe<Scalars['String']>;
};


export type QuerySendSupportMessageArgs = {
  docRef: ISendSupportMessageInput;
};


export type QueryStockStatusArgs = {
  assetUnitIds: Array<Scalars['String']>;
};


export type QueryStorageAndInsuranceDetailsArgs = {
  financeOperationId: Scalars['Int'];
};


export type QuerySuggestActiveMarketWinesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchMethod: SearchMethod;
  text?: InputMaybe<Scalars['String']>;
};


export type QuerySuggestWineVintagesArgs = {
  queryString: Scalars['String'];
};


export type QuerySuggestWinesArgs = {
  queryString: Scalars['String'];
};


export type QueryUserExistsArgs = {
  email: Scalars['String'];
};


export type QueryUserLocationInfoArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryUserNotificationsArgs = {
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryValidReferralCodeArgs = {
  code: Scalars['String'];
};


export type QueryValidatePortalEmailArgs = {
  emailAddress: Scalars['String'];
};


export type QueryValidatePostCodeArgs = {
  postcodePrefix: Scalars['String'];
};


export type QueryWatchListItemsArgs = {
  groupId?: InputMaybe<Scalars['Int']>;
};


export type QueryWatchlistGroupsArgs = {
  groupId?: InputMaybe<Scalars['Int']>;
};

export type QuickInvestOrder = {
  __typename?: 'QuickInvestOrder';
  asset: Asset;
  direction: Scalars['Int'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
};

export type ReceivedBidsResponse = {
  __typename?: 'ReceivedBidsResponse';
  count?: Maybe<Scalars['Int']>;
  results: Array<ReceivedBidsResult>;
};

export type ReceivedBidsResult = {
  __typename?: 'ReceivedBidsResult';
  appellation?: Maybe<Scalars['String']>;
  assetId: Scalars['Int'];
  autoCancelTimeUtc?: Maybe<Scalars['String']>;
  bookedTimeUtc?: Maybe<Scalars['String']>;
  calculatedMarketData?: Maybe<CalculatedMarketData>;
  clientOrderId?: Maybe<Scalars['String']>;
  imageFileName?: Maybe<Scalars['String']>;
  initialQuantity?: Maybe<Scalars['Int']>;
  lwin18?: Maybe<Scalars['String']>;
  manualCancelTimeUtc?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  orderInfo?: Maybe<OrderSpread>;
  price?: Maybe<Scalars['Float']>;
  productUrn?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  quantityOutstanding?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tradingInfo?: Maybe<TradingInfo>;
  unitCount?: Maybe<Scalars['Int']>;
  unitSize?: Maybe<Scalars['String']>;
  vintage?: Maybe<Scalars['Int']>;
  wineName?: Maybe<Scalars['String']>;
};

export type RecommendationInput = {
  clientType: Scalars['String'];
  maxPrice?: InputMaybe<Scalars['Float']>;
  minPrice: Scalars['Float'];
  producer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  region?: InputMaybe<Array<Scalars['String']>>;
  style?: InputMaybe<Scalars['String']>;
  window?: InputMaybe<WindowOption>;
};

export type RecurringPaymentPriceItem = {
  __typename?: 'RecurringPaymentPriceItem';
  currency: Scalars['String'];
  id: Scalars['String'];
  nickName?: Maybe<Scalars['String']>;
  product: Scalars['String'];
  recurringInterval: Scalars['String'];
  recurringIntervalCount: Scalars['Int'];
  unitAmount: Scalars['Float'];
};

export type RecurringPaymentResponse = {
  __typename?: 'RecurringPaymentResponse';
  amount?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paymentMethodId?: Maybe<Scalars['String']>;
  portfolioId: Scalars['Int'];
  portfolioName?: Maybe<Scalars['String']>;
  priceId: Scalars['String'];
  status: Scalars['String'];
};

export type RedeemStatusEntry = {
  __typename?: 'RedeemStatusEntry';
  amount?: Maybe<Scalars['Float']>;
  dateTime: Scalars['String'];
  failureReason?: Maybe<Scalars['String']>;
  status: RedeemStatusValue;
};

export enum RedeemStatusValue {
  Failed = 'Failed',
  Success = 'Success'
}

export type ReferralCode = {
  __typename?: 'ReferralCode';
  code?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  expiryDateTime?: Maybe<Scalars['String']>;
  firstPurchaseAt?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  refereeAmount?: Maybe<Scalars['Float']>;
  referreeId?: Maybe<Scalars['String']>;
  referrerAmount?: Maybe<Scalars['Float']>;
  referrerId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ReferralCodeData = {
  __typename?: 'ReferralCodeData';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supersededAt?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['String']>;
};

export type Region = {
  __typename?: 'Region';
  anglophoneCountryName?: Maybe<Scalars['String']>;
  countryIsoCode: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  regionName?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
};

export type RegionFilter = {
  __typename?: 'RegionFilter';
  country?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
};

export type RegisterWithMfaInput = {
  accountHolderId?: InputMaybe<Scalars['Int']>;
  accountType?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hasAgreedToMarketing?: InputMaybe<Scalars['Boolean']>;
  hasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  incentiveCode?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  registeredByApp?: InputMaybe<Scalars['String']>;
  residenceCountry?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type RegisterWithMfaResponse = {
  __typename?: 'RegisterWithMfaResponse';
  accessToken?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  errorDescription?: Maybe<Scalars['String']>;
  idToken?: Maybe<Scalars['String']>;
  mfaToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  userToken?: Maybe<Scalars['String']>;
};

export enum RegisteredByApp {
  CultXChina = 'CultXChina'
}

export enum RegistrationType {
  EmailAddress = 'EmailAddress',
  PhoneNumber = 'PhoneNumber'
}

export type ReinstateBidInitiatedInput = {
  orderIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ReinstateBidInitiatedResponse = {
  __typename?: 'ReinstateBidInitiatedResponse';
  clientOrderId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  initiated: Scalars['Boolean'];
};

export type RelatedVintagesResponse = {
  __typename?: 'RelatedVintagesResponse';
  results?: Maybe<Array<Maybe<RelatedVintagesResults>>>;
  size?: Maybe<Scalars['Int']>;
};

export type RelatedVintagesResults = {
  __typename?: 'RelatedVintagesResults';
  assetId?: Maybe<Scalars['Int']>;
  calculatedMarketData?: Maybe<CalculatedMarketData>;
  caseSize?: Maybe<Scalars['String']>;
  highestBid?: Maybe<Scalars['Float']>;
  highestBidPerBottle?: Maybe<Scalars['Float']>;
  lastTraded?: Maybe<Scalars['String']>;
  lastTradedValue?: Maybe<Scalars['Float']>;
  lowestPhysicalOffer?: Maybe<Scalars['Float']>;
  lowestPhysicalOfferPerBottle?: Maybe<Scalars['Float']>;
  lwin11?: Maybe<Scalars['String']>;
  lwin18?: Maybe<Scalars['String']>;
  marketValuePerBottle?: Maybe<Scalars['Float']>;
  normalizedCriticScore?: Maybe<Scalars['Float']>;
  orderInfo?: Maybe<OrderSpread>;
  productUrn?: Maybe<Scalars['String']>;
  vinousScore?: Maybe<Scalars['Float']>;
  vintage?: Maybe<Scalars['Int']>;
  waScore?: Maybe<Scalars['Float']>;
};

export type RequestLotPhotosResponse = {
  __typename?: 'RequestLotPhotosResponse';
  errorMessage?: Maybe<Scalars['String']>;
  /** Buyer-facing fee actually charged, in pence (or local minor units). */
  feeChargedPence?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ResultObj = {
  __typename?: 'ResultObj';
  cashAccountId?: Maybe<Scalars['String']>;
  preference?: Maybe<Scalars['Boolean']>;
};

export type RewardBalanceResult = {
  __typename?: 'RewardBalanceResult';
  availableCredit: Scalars['Float'];
};

export type RewardConfigResult = {
  __typename?: 'RewardConfigResult';
  currency?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  refereeAmount?: Maybe<Scalars['Float']>;
  referrerAmount?: Maybe<Scalars['Float']>;
};

export type RewardSettingResult = {
  __typename?: 'RewardSettingResult';
  preference?: Maybe<Scalars['Boolean']>;
};

export type SaveOnboardingStepsResponse = {
  __typename?: 'SaveOnboardingStepsResponse';
  errorMessage?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SavePortfolioGeneratorInput = {
  budget?: InputMaybe<Scalars['Float']>;
  investmentStrategy?: InputMaybe<Scalars['String']>;
  liquidityStrategy?: InputMaybe<Scalars['String']>;
  riskStrategy?: InputMaybe<Scalars['String']>;
};

export type SavePortfolioGeneratorResponse = {
  __typename?: 'SavePortfolioGeneratorResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<SavePortfolioGeneratorResult>;
  status?: Maybe<Scalars['String']>;
};

export type SavePortfolioGeneratorResult = {
  __typename?: 'SavePortfolioGeneratorResult';
  budget?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  investmentStrategy?: Maybe<Scalars['String']>;
  liquidityStrategy?: Maybe<Scalars['String']>;
  riskStrategy?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type SaveSearchHistoryResult = {
  __typename?: 'SaveSearchHistoryResult';
  errorMessage?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SaveUserRegistrationInput = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hasAgreedToMarketing?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  primaryGoal?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  residenceCountry?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type SaveUserRegistrationResponse = {
  __typename?: 'SaveUserRegistrationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<SavedUserRegistration>;
  status: Scalars['String'];
};

export type SavedUserRegistration = {
  __typename?: 'SavedUserRegistration';
  dateOfBirth?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hasAgreedToMarketing?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  primaryGoal?: Maybe<Scalars['String']>;
  residenceCountry?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type SearchBidsFacets = {
  __typename?: 'SearchBidsFacets';
  BidStatus: Scalars['JSON'];
  MyBid: Scalars['JSON'];
  Region: Scalars['JSON'];
  UnitCount: Scalars['JSON'];
  UnitSize: Scalars['JSON'];
  Vintage: Scalars['JSON'];
  WineName: Scalars['JSON'];
};

export type SearchBidsResult = {
  __typename?: 'SearchBidsResult';
  facets: SearchBidsFacets;
  results: Array<BidsResult>;
  total: Scalars['Int'];
};

export type SearchHoldingFacets = {
  __typename?: 'SearchHoldingFacets';
  MarketValue: Scalars['JSON'];
  PercentageDifference: Scalars['JSON'];
  Region: Scalars['JSON'];
  Score: Scalars['JSON'];
  TotalPurchasedPrice: Scalars['JSON'];
  UnitCount: Scalars['JSON'];
  UnitSize: Scalars['JSON'];
  Vintage: Scalars['JSON'];
  WineName: Scalars['JSON'];
};

export type SearchHoldingResult = {
  __typename?: 'SearchHoldingResult';
  facets: SearchHoldingFacets;
  results: Array<HoldingResult>;
  total: Scalars['Int'];
};

export enum SearchMethod {
  contains = 'contains',
  startWith = 'startWith'
}

export type SearchOffersFacets = {
  __typename?: 'SearchOffersFacets';
  MyOffer: Scalars['JSON'];
  OfferStatus: Scalars['JSON'];
  Region: Scalars['JSON'];
  UnitCount: Scalars['JSON'];
  UnitSize: Scalars['JSON'];
  Vintage: Scalars['JSON'];
  WineName: Scalars['JSON'];
};

export type SearchOffersResult = {
  __typename?: 'SearchOffersResult';
  facets: SearchOffersFacets;
  results: Array<OffersResult>;
  total: Scalars['Int'];
};

export type SearchRecommendationResults = {
  __typename?: 'SearchRecommendationResults';
  lwin7?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  searchCount?: Maybe<Scalars['Int']>;
};

export type SearchWatchlistFacets = {
  __typename?: 'SearchWatchlistFacets';
  MarketValue: Scalars['JSON'];
  PercentageDifference: Scalars['JSON'];
  Region: Scalars['JSON'];
  Score: Scalars['JSON'];
  UnitCount: Scalars['JSON'];
  UnitSize: Scalars['JSON'];
  Vintage: Scalars['JSON'];
  WineName: Scalars['JSON'];
};

export type SearchWatchlistResult = {
  __typename?: 'SearchWatchlistResult';
  facets: SearchWatchlistFacets;
  results: Array<WatchlistResult>;
  total: Scalars['Int'];
};

export type SearchWineVintagesFacets = {
  __typename?: 'SearchWineVintagesFacets';
  Appellation: Scalars['JSON'];
  Classification: Scalars['JSON'];
  LiquidityRank?: Maybe<Scalars['JSON']>;
  MarketValue: Scalars['JSON'];
  PercentageDifference: Scalars['JSON'];
  Producer: Scalars['JSON'];
  Region: Scalars['JSON'];
  Score: Scalars['JSON'];
  Vintage: Scalars['JSON'];
  WineName: Scalars['JSON'];
};

export type SearchWineVintagesFacetsResult = {
  __typename?: 'SearchWineVintagesFacetsResult';
  facets: SearchWineVintagesFacets;
};

export type SearchWineVintagesResult = {
  __typename?: 'SearchWineVintagesResult';
  results: Array<WineVintageResult>;
  total: Scalars['Int'];
};

export type SendMessageResult = {
  __typename?: 'SendMessageResult';
  queryId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
};

export type SetCustomReferralCodeResult = {
  __typename?: 'SetCustomReferralCodeResult';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<CustomReferralCodeResult>;
  status?: Maybe<Scalars['String']>;
};

export type SetRewardSettingResult = {
  __typename?: 'SetRewardSettingResult';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<ResultObj>;
  status?: Maybe<Scalars['String']>;
};

export type SettleInvoicesInput = {
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  instrumentId?: InputMaybe<Scalars['String']>;
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  reference?: InputMaybe<Scalars['String']>;
};

export type SettleInvoicesResponse = {
  __typename?: 'SettleInvoicesResponse';
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
};

export type ShareWatchlistAssetsInput = {
  assetIds: Array<Scalars['Int']>;
  email: Scalars['String'];
  groupName: Scalars['String'];
};

export type ShareWatchlistResponse = {
  __typename?: 'ShareWatchlistResponse';
  groupId: Scalars['Int'];
  groupName: Scalars['String'];
  sharedAssetIds: Array<Scalars['Int']>;
};

export type SpreadOrder = {
  __typename?: 'SpreadOrder';
  assetId?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  unitCount?: Maybe<Scalars['Int']>;
  unitSize?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type StockStatusResponse = {
  __typename?: 'StockStatusResponse';
  assetUnits: Array<Maybe<StockStatusResult>>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type StockStatusResult = {
  __typename?: 'StockStatusResult';
  assetUnitId?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
};

export type StorageAndInsuranceDetail = {
  __typename?: 'StorageAndInsuranceDetail';
  assetUnitIds?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lwin18: Scalars['String'];
  quantity: Scalars['Int'];
  totalCharge: Scalars['Float'];
  unitSize?: Maybe<Scalars['String']>;
  vintage?: Maybe<Scalars['Int']>;
  wineName?: Maybe<Scalars['String']>;
};

export type StorageAndInsuranceResponse = {
  __typename?: 'StorageAndInsuranceResponse';
  id: Scalars['Int'];
  operationAmountGbp: Scalars['Float'];
  operationCurrency: Scalars['String'];
  operationDate: Scalars['String'];
  operationSource?: Maybe<Scalars['String']>;
  operationType: Scalars['String'];
  userId: Scalars['String'];
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type StripeCardItem = {
  __typename?: 'StripeCardItem';
  billingAddress: StripeAddress;
  brand: Scalars['String'];
  country: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  funding: Scalars['String'];
  id: Scalars['String'];
  last4: Scalars['String'];
};

export type StripePaymentInput = {
  amount: Scalars['Float'];
  portfolioId: Scalars['Int'];
};

export type StripePaymentResponse = {
  __typename?: 'StripePaymentResponse';
  clientSecret: Scalars['String'];
  id: Scalars['String'];
  paymentIntentId: Scalars['String'];
};

export type StripeRecurringPaymentInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  defaultPaymentMethod?: InputMaybe<Scalars['String']>;
  frequency: Scalars['String'];
  portfolioId: Scalars['Int'];
  priceId: Scalars['String'];
};

export type StripeRecurringPaymentResponse = {
  __typename?: 'StripeRecurringPaymentResponse';
  clientSecret: Scalars['String'];
  id: Scalars['String'];
  subId: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  getActiveMarket: LiveActiveMarketResult;
  getMyOrder: Order;
  getMyTrades: TradeSubscription;
  getMyTransferOutRequest: TransferOutRequest;
  getNotification: NotificationRequest;
  getOrderBooksByAssetId: OrderBook;
  getOrderByAssetId: Order;
};


export type SubscriptionGetActiveMarketArgs = {
  wineName?: InputMaybe<Scalars['String']>;
};


export type SubscriptionGetOrderBooksByAssetIdArgs = {
  assetId: Scalars['Int'];
};


export type SubscriptionGetOrderByAssetIdArgs = {
  assetId: Scalars['Int'];
};

export type SuggestActiveMarketWinesResults = {
  __typename?: 'SuggestActiveMarketWinesResults';
  isActiveMarket?: Maybe<Scalars['Boolean']>;
  isCommunity?: Maybe<Scalars['Boolean']>;
  lwin7?: Maybe<Scalars['String']>;
  producer?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  wineName?: Maybe<Scalars['String']>;
};

export type SuggestWineVintagesResult = {
  __typename?: 'SuggestWineVintagesResult';
  suggestedAppellation: Array<SuggestedAppellation>;
  suggestedProducer: Array<SuggestedProducer>;
  suggestedRegion: Array<SuggestedRegion>;
  suggests: Array<WineVintageSuggestion>;
};

export type SuggestWinesResult = {
  __typename?: 'SuggestWinesResult';
  suggests: Array<WineSuggestion>;
};

export type SuggestedAppellation = {
  __typename?: 'SuggestedAppellation';
  appellation: Scalars['String'];
};

export type SuggestedProducer = {
  __typename?: 'SuggestedProducer';
  producer: Scalars['String'];
};

export type SuggestedRegion = {
  __typename?: 'SuggestedRegion';
  region: Scalars['String'];
};

export enum TaskStateEnumType {
  Bid = 'Bid',
  Offer = 'Offer'
}

export type Trade = {
  __typename?: 'Trade';
  assetId: Scalars['Int'];
  bid: IFilledOrder;
  id: Scalars['ID'];
  offer: IFilledOrder;
  price: Scalars['Float'];
  size: Scalars['Int'];
};

export type TradeSubscription = {
  __typename?: 'TradeSubscription';
  assetId: Scalars['Int'];
  assetUnitIds: Array<Scalars['String']>;
  bid: BidOfferModel;
  id: Scalars['ID'];
  offer: BidOfferModel;
  tradeDateTime: Scalars['String'];
};

export type TradingInfo = {
  __typename?: 'TradingInfo';
  lastTraded?: Maybe<Scalars['String']>;
  lastTradedValue?: Maybe<Scalars['Float']>;
  tradesMTD: Scalars['Float'];
  tradesYTD: Scalars['Float'];
};

export type TransferInventoryOutV2Input = {
  assetUnitIds: Array<Scalars['String']>;
  bestContactNumber?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
  deliveryInstructions?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<Scalars['String']>;
};

export type TransferInventoryOutV2Response = {
  __typename?: 'TransferInventoryOutV2Response';
  assetUnitIds?: Maybe<Array<Scalars['String']>>;
  errorMessage?: Maybe<Scalars['String']>;
  initiated: Scalars['Boolean'];
};

export type TransferOutRequest = {
  __typename?: 'TransferOutRequest';
  assetUnitIds: Array<Scalars['String']>;
  isSuccess: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UnitSizeDto = {
  __typename?: 'UnitSizeDto';
  buyingTransactionId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  unitSizeId?: Maybe<Scalars['Int']>;
};

export type UnlockStocksInput = {
  assetUnitIds: Array<Scalars['String']>;
};

export type UnlockStocksResponse = {
  __typename?: 'UnlockStocksResponse';
  errorMessage?: Maybe<Scalars['String']>;
  initiated: Scalars['Boolean'];
};

export type UpdateCultxPreferencesInput = {
  currency?: InputMaybe<Scalars['String']>;
  deliveryCountry?: InputMaybe<Scalars['String']>;
  deliveryRegion?: InputMaybe<Scalars['String']>;
  purchaseDeliveryType?: InputMaybe<Scalars['String']>;
};

export type UpdateCultxPreferencesResponse = {
  __typename?: 'UpdateCultxPreferencesResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<UpdateCultxPreferencesResult>;
  status: Scalars['String'];
};

export type UpdateCultxPreferencesResult = {
  __typename?: 'UpdateCultxPreferencesResult';
  createdDateTime?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deliveryCountry?: Maybe<Scalars['String']>;
  deliveryRegion?: Maybe<Scalars['String']>;
  purchaseDeliveryType?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type UpdateDefaultMitCardResponse = {
  __typename?: 'UpdateDefaultMitCardResponse';
  errorMessage?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type UpdateMitConsentInput = {
  consentFlag: Scalars['Boolean'];
  instrumentId: Scalars['String'];
};

export type UpdateMitConsentResponse = {
  __typename?: 'UpdateMitConsentResponse';
  errorMessage?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type UpdatePaymentDetailInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  bicOrSwift?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  nameOnAccount?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
};

export type UpdatePreferencesInput = {
  annualManagementFeePayType?: InputMaybe<Scalars['String']>;
  autoTrade?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  historicManagementFeePayType?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  managementFeePayment?: InputMaybe<Scalars['String']>;
};

export type UpdateStripeRecurringPaymentInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  defaultPaymentMethod?: InputMaybe<Scalars['String']>;
  frequency: Scalars['String'];
  priceId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type UpdateStripeRecurringPaymentResponse = {
  __typename?: 'UpdateStripeRecurringPaymentResponse';
  hasUpdated: Scalars['Boolean'];
  subscriptionId: Scalars['String'];
};

export type UpdateUserQuickSearchInput = {
  bottlePriceMax?: InputMaybe<Scalars['Float']>;
  bottlePriceMin?: InputMaybe<Scalars['Float']>;
  colour?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  listingType?: InputMaybe<Array<Scalars['String']>>;
  marketPrice?: InputMaybe<Array<Scalars['String']>>;
  offerPrice?: InputMaybe<Array<Scalars['String']>>;
  performanceMax?: InputMaybe<Scalars['Float']>;
  performanceMin?: InputMaybe<Scalars['Float']>;
  preferenceName: Scalars['String'];
  producer?: InputMaybe<Array<Scalars['String']>>;
  region?: InputMaybe<Array<Scalars['String']>>;
  score?: InputMaybe<Array<Scalars['String']>>;
  unitSize?: InputMaybe<Array<Scalars['String']>>;
  vintage?: InputMaybe<Array<Scalars['String']>>;
  wineName?: InputMaybe<Scalars['String']>;
};

export type UserDeviceToken = {
  __typename?: 'UserDeviceToken';
  deviceId: Scalars['String'];
  id: Scalars['String'];
  platform: Scalars['Int'];
};

export type UserHolding = {
  __typename?: 'UserHolding';
  activeOfferQuantity: Scalars['Int'];
  asset: Asset;
  calculatedMarketData: CalculatedMarketData;
  storageStatus?: Maybe<Scalars['String']>;
  totalMarketValuation: Scalars['Float'];
  totalPhysicalQuantity: Scalars['Int'];
  totalPurchasePrice: Scalars['Float'];
  totalQuantityOwned: Scalars['Int'];
};

export type UserLocationInfo = {
  __typename?: 'UserLocationInfo';
  countriesCodes: Array<CountryCurrency>;
  countriesCodesSize: Scalars['Int'];
  countryCode?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
};

export type UserQuickSearch = {
  __typename?: 'UserQuickSearch';
  bottlePriceMax?: Maybe<Scalars['Float']>;
  bottlePriceMin?: Maybe<Scalars['Float']>;
  colour?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  listingType?: Maybe<Array<Scalars['String']>>;
  marketPrice?: Maybe<Array<Scalars['String']>>;
  offerPrice?: Maybe<Array<Scalars['String']>>;
  performanceMax?: Maybe<Scalars['Float']>;
  performanceMin?: Maybe<Scalars['Float']>;
  preferenceName: Scalars['String'];
  producer?: Maybe<Array<Scalars['String']>>;
  region?: Maybe<Array<Scalars['String']>>;
  score?: Maybe<Array<Scalars['String']>>;
  unitSize?: Maybe<Array<Scalars['String']>>;
  vintage?: Maybe<Array<Scalars['String']>>;
  wineName?: Maybe<Scalars['String']>;
};

export type UserQuickSearchInput = {
  bottlePriceMax?: InputMaybe<Scalars['Float']>;
  bottlePriceMin?: InputMaybe<Scalars['Float']>;
  colour?: InputMaybe<Array<Scalars['String']>>;
  listingType?: InputMaybe<Array<Scalars['String']>>;
  marketPrice?: InputMaybe<Array<Scalars['String']>>;
  offerPrice?: InputMaybe<Array<Scalars['String']>>;
  performanceMax?: InputMaybe<Scalars['Float']>;
  performanceMin?: InputMaybe<Scalars['Float']>;
  preferenceName: Scalars['String'];
  producer?: InputMaybe<Array<Scalars['String']>>;
  region?: InputMaybe<Array<Scalars['String']>>;
  score?: InputMaybe<Array<Scalars['String']>>;
  unitSize?: InputMaybe<Array<Scalars['String']>>;
  vintage?: InputMaybe<Array<Scalars['String']>>;
  wineName?: InputMaybe<Scalars['String']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  currency: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  useLoginEmail: Scalars['Boolean'];
};

export type ValidReferralCodeResult = {
  __typename?: 'ValidReferralCodeResult';
  isValid: Scalars['Boolean'];
};

export type ValidatePostCodeResult = {
  __typename?: 'ValidatePostCodeResult';
  isValid: Scalars['Boolean'];
  postcodeDistrict?: Maybe<Scalars['String']>;
  postcodePrefix?: Maybe<Scalars['String']>;
};

export type WatchListHolding = {
  __typename?: 'WatchListHolding';
  performance: HoldingPerformanceResponse;
  score: Scalars['Int'];
};

export type WatchListItem = {
  __typename?: 'WatchListItem';
  addedToWatchListDate: Scalars['String'];
  asset: Asset;
  calculatedMarketData: CalculatedMarketData;
};

export type WatchlistGroup = {
  __typename?: 'WatchlistGroup';
  createdDateTime: Scalars['String'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  name: Scalars['String'];
  updatedDateTime?: Maybe<Scalars['String']>;
};

export type WatchlistGroupItem = {
  __typename?: 'WatchlistGroupItem';
  createdDateTime: Scalars['String'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  updatedDateTime?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type WatchlistResult = {
  __typename?: 'WatchlistResult';
  appellation?: Maybe<Scalars['String']>;
  assetId: Scalars['Int'];
  calculatedMarketData: CalculatedMarketData;
  docId: Scalars['String'];
  marketValue: Scalars['Float'];
  region: Scalars['String'];
  score: Scalars['String'];
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int'];
  unitSize: Scalars['String'];
  vintage: Scalars['Int'];
  watchlistItemId: Scalars['Int'];
  wineName: Scalars['String'];
};

export enum WindowOption {
  LONG = 'LONG',
  MEDIUM = 'MEDIUM',
  SHORT = 'SHORT'
}

export type Wine = {
  __typename?: 'Wine';
  appellation?: Maybe<Appellation>;
  appellationId?: Maybe<Scalars['Int']>;
  classification?: Maybe<Scalars['String']>;
  composition?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  firstVintage?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isSingleVintage: Scalars['Boolean'];
  lastVintage?: Maybe<Scalars['Int']>;
  lwin7?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  producer?: Maybe<Producer>;
  producerId?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['Int']>;
  regionalisedWineColour?: Maybe<Scalars['String']>;
  seoFriendlyName?: Maybe<Scalars['String']>;
  sequentialVintages?: Maybe<Scalars['Boolean']>;
  sparkling?: Maybe<Scalars['Boolean']>;
  storingPosition?: Maybe<Scalars['String']>;
  sweetness?: Maybe<Scalars['String']>;
  vintages: Array<WineVintage>;
  wineColourCode?: Maybe<Scalars['String']>;
  wineScores: Array<WineScore>;
};

export type WineMatrix = {
  __typename?: 'WineMatrix';
  classification?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lwin?: Maybe<Scalars['String']>;
  producer?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  tabData: Array<WineMatrixData>;
  wineName?: Maybe<Scalars['String']>;
};

export type WineMatrixData = {
  __typename?: 'WineMatrixData';
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type WineMatrixFilters = {
  bottlePrice?: InputMaybe<Scalars['String']>;
  classification?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  liquidity?: InputMaybe<Scalars['String']>;
  producer?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['String']>;
  wsGrade?: InputMaybe<Scalars['String']>;
};

export type WineMatrixFiltersResult = {
  __typename?: 'WineMatrixFiltersResult';
  bottlePrice?: Maybe<Array<Maybe<Scalars['Float']>>>;
  classification?: Maybe<Array<Maybe<Scalars['String']>>>;
  country?: Maybe<Array<Maybe<Scalars['String']>>>;
  liquidity?: Maybe<Array<Maybe<Scalars['Float']>>>;
  producer?: Maybe<Array<Maybe<Scalars['String']>>>;
  region?: Maybe<Array<Maybe<Scalars['String']>>>;
  score?: Maybe<Array<Maybe<Scalars['Float']>>>;
  tier?: Maybe<Array<Maybe<Scalars['String']>>>;
  wsGrade?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type WineMatrixResult = {
  __typename?: 'WineMatrixResult';
  results: Array<WineMatrix>;
  total: Scalars['Int'];
};

export type WineMatrixVintageRangeResult = {
  __typename?: 'WineMatrixVintageRangeResult';
  maxMinBsubset?: Maybe<Scalars['Float']>;
  maxTradeCount?: Maybe<Scalars['Float']>;
  maxVintage?: Maybe<Scalars['Int']>;
  maxWs1b?: Maybe<Scalars['Float']>;
  minMinBsubset?: Maybe<Scalars['Float']>;
  minTradeCount?: Maybe<Scalars['Float']>;
  minVintage?: Maybe<Scalars['Int']>;
  minWs1b?: Maybe<Scalars['Float']>;
};

export type WinePreference = {
  __typename?: 'WinePreference';
  decisionMethods?: Maybe<Array<Scalars['String']>>;
  enjoyTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maxBudget?: Maybe<Scalars['Float']>;
  minBudget?: Maybe<Scalars['Float']>;
  regions?: Maybe<Array<Scalars['String']>>;
  styles?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Scalars['String']>;
};

export type WinePreferenceInput = {
  decisionMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enjoyTime?: InputMaybe<Scalars['String']>;
  maxBudget?: InputMaybe<Scalars['Float']>;
  minBudget?: InputMaybe<Scalars['Float']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  styles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WinePreferenceResponse = {
  __typename?: 'WinePreferenceResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<WinePreference>;
  status?: Maybe<Scalars['String']>;
};

export type WineRecommendationInput = {
  decisionMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enjoyTime?: InputMaybe<Scalars['String']>;
  maxBudget?: InputMaybe<Scalars['Float']>;
  minBudget?: InputMaybe<Scalars['Float']>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startingBudget?: InputMaybe<Scalars['Float']>;
};

export type WineRecommendationResponse = {
  __typename?: 'WineRecommendationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<WineRecommendationResult>;
  status?: Maybe<Scalars['String']>;
};

export type WineRecommendationResult = {
  __typename?: 'WineRecommendationResult';
  decisionMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  enjoyTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  maxBudget?: Maybe<Scalars['Float']>;
  minBudget?: Maybe<Scalars['Float']>;
  producers?: Maybe<Array<Maybe<Scalars['String']>>>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  startingBudget?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['ID']>;
};

export type WineScore = {
  __typename?: 'WineScore';
  score?: Maybe<Scalars['Float']>;
  scoreDate?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  tastingNotes?: Maybe<Scalars['String']>;
};

export type WineSearcherOffer = {
  __typename?: 'WineSearcherOffer';
  lwin18: Scalars['String'];
  price: Scalars['Float'];
};

export type WineSuggestion = {
  __typename?: 'WineSuggestion';
  wineId: Scalars['Int'];
  wineName: Scalars['String'];
};

export type WineVintage = {
  __typename?: 'WineVintage';
  alcoholPct?: Maybe<Scalars['Float']>;
  assets: Array<Asset>;
  calculatedMarketData: CalculatedMarketData;
  closureType?: Maybe<Scalars['String']>;
  drinkingWindow: WineVintageDrinkingWindow;
  id: Scalars['Int'];
  imageFileName?: Maybe<Scalars['String']>;
  lwin11?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  vintage: Scalars['Int'];
  wine: Wine;
  wineId: Scalars['Int'];
  wineScores: Array<WineScore>;
};

export type WineVintageDrinkingWindow = {
  __typename?: 'WineVintageDrinkingWindow';
  advice: Scalars['String'];
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
};

export type WineVintageResult = {
  __typename?: 'WineVintageResult';
  appellation?: Maybe<Scalars['String']>;
  calculatedMarketData: CalculatedMarketData;
  classification?: Maybe<Scalars['String']>;
  defaultAsset: Asset;
  defaultAssetId: Scalars['Int'];
  drinkingWindow: WineVintageDrinkingWindow;
  lastTradeDate?: Maybe<Scalars['String']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  lwin7: Scalars['String'];
  lwin11: Scalars['String'];
  marketData: MarketData;
  marketValue: Scalars['Float'];
  percentageDifference?: Maybe<Scalars['String']>;
  producer?: Maybe<Scalars['String']>;
  region: Scalars['String'];
  score?: Maybe<Scalars['String']>;
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int'];
  unitSize: Scalars['String'];
  vintage: Scalars['Int'];
  wineColour?: Maybe<Scalars['String']>;
  wineId: Scalars['Int'];
  wineName: Scalars['String'];
  wineVintageId: Scalars['Int'];
};


export type WineVintageResultMarketDataArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};

export type WineVintageSuggestion = {
  __typename?: 'WineVintageSuggestion';
  appellation: Scalars['String'];
  defaultAssetId: Scalars['Int'];
  lwin11: Scalars['String'];
  producer: Scalars['String'];
  region: Scalars['String'];
  vintage: Scalars['Int'];
  wineId: Scalars['Int'];
  wineName: Scalars['String'];
  wineVintageId: Scalars['Int'];
};

export type WithdrawConfirmationInput = {
  accountName: Scalars['String'];
  accountNumber?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  bic?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
};

export type WithdrawConfirmationResponse = {
  __typename?: 'WithdrawConfirmationResponse';
  accountName: Scalars['String'];
  accountNumber?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  bic?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type WithdrawPaymentDetail = {
  __typename?: 'WithdrawPaymentDetail';
  accountNumber?: Maybe<Scalars['String']>;
  bicOrSwift?: Maybe<Scalars['String']>;
  createdDateTime: Scalars['String'];
  iban?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  nameOnAccount?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['String'];
};

export type GetMiscellaneousQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMiscellaneousQuery = { __typename?: 'Query', miscellaneous?: { __typename?: 'MiscellaneousType', languages?: Array<{ __typename?: 'MiscellaneousItem', id: string, value?: string | null, symbol?: string | null, text: string } | null> | null, currencies?: Array<{ __typename?: 'MiscellaneousItem', id: string, value?: string | null, text: string, symbol?: string | null } | null> | null, paymentFrequencies?: Array<{ __typename?: 'MiscellaneousItem', id: string, value?: string | null, text: string } | null> | null } | null };

export type GetUserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPreferencesQuery = { __typename?: 'Query', portalClientPreferences?: { __typename?: 'PortalClientPreferencesResponse', currency: string, language: string, firstLoginDate?: string | null, managementFeePayment?: string | null, annualManagementFeePayType?: string | null, historicManagementFeePayType?: string | null, bankTransferChaseEmailCount: number, autoTrade?: boolean | null } | null };

export type AiChatAuthUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AiChatAuthUserQuery = { __typename?: 'Query', authUser: { __typename?: 'AuthUser', emailAddress: string } };

export type AuthChangePasswordMutationVariables = Exact<{
  changePasswordInput: AuthChangePasswordInput;
}>;


export type AuthChangePasswordMutation = { __typename?: 'Mutation', authChangePassword: { __typename?: 'AuthChangePasswordResponse', wasPasswordChanged: boolean } };

export type CreatePaymentSessionMutationVariables = Exact<{
  paymentSession: PaymentSessionInput;
}>;


export type CreatePaymentSessionMutation = { __typename?: 'Mutation', createPaymentSession: { __typename?: 'PaymentSessionResponse', errorMessage?: string | null, id: string, paymentSessionSecret?: string | null, paymentSessionToken: string, referenceId?: string | null } };

export type CreateStripeRecurringPaymentMutationVariables = Exact<{
  stripeRecurringPayment: StripeRecurringPaymentInput;
}>;


export type CreateStripeRecurringPaymentMutation = { __typename?: 'Mutation', createStripeRecurringPayment: { __typename?: 'StripeRecurringPaymentResponse', id: string, subId: string, clientSecret: string } };

export type DeletePaymentCardMutationVariables = Exact<{
  instrumentId: Scalars['String'];
}>;


export type DeletePaymentCardMutation = { __typename?: 'Mutation', deleteCardDetail: { __typename?: 'CardDetailDeletedResult', isSuccess?: boolean | null, errorMessage?: string | null } };

export type FinalizePaymentSessionMutationVariables = Exact<{
  finalizePaymentSession: FinalizePaymentSessionInput;
}>;


export type FinalizePaymentSessionMutation = { __typename?: 'Mutation', finalizePaymentSession: { __typename?: 'FinalizePaymentSessionResponse', status?: string | null, providerPaymentId?: string | null, referenceId?: string | null, errorMessage?: string | null } };

export type AuthUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthUserQuery = { __typename?: 'Query', authUser: { __typename?: 'AuthUser', emailAddress: string, fullName: string } };

export type PaymentReferenceNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentReferenceNumberQuery = { __typename?: 'Query', paymentReferenceNumber?: string | null };

export type PaymentGetCardDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentGetCardDetailsQuery = { __typename?: 'Query', paymentGetCardDetails?: Array<{ __typename?: 'CardDetailResponse', instrumentId?: string | null, last4?: string | null, clientName?: string | null, expiry?: string | null, scheme?: string | null, mitConsentedFlag?: boolean | null, defaultMitFlag?: boolean | null }> | null };

export type RecurringPaymentPricesQueryVariables = Exact<{
  currency: Scalars['String'];
}>;


export type RecurringPaymentPricesQuery = { __typename?: 'Query', recurringPaymentPrices?: Array<{ __typename?: 'RecurringPaymentPriceItem', id: string, nickName?: string | null, product: string, currency: string, unitAmount: number, recurringInterval: string, recurringIntervalCount: number }> | null };

export type CreateStripePaymentMutationVariables = Exact<{
  stripePayment: StripePaymentInput;
}>;


export type CreateStripePaymentMutation = { __typename?: 'Mutation', createStripePayment: { __typename?: 'StripePaymentResponse', id: string, paymentIntentId: string, clientSecret: string } };

export type UpdateDefaultCheckoutDotComCardMutationVariables = Exact<{
  defaultMitCard: DefaultMitCardInput;
}>;


export type UpdateDefaultCheckoutDotComCardMutation = { __typename?: 'Mutation', updateDefaultMitCard: { __typename?: 'UpdateDefaultMitCardResponse', status: boolean, errorMessage?: string | null } };

export type PortalUpdatePreferencesMutationVariables = Exact<{
  request: UpdatePreferencesInput;
}>;


export type PortalUpdatePreferencesMutation = { __typename?: 'Mutation', portalUpdatePreferences: { __typename?: 'PortalClientPreferencesResponse', currency: string, language: string, managementFeePayment?: string | null, annualManagementFeePayType?: string | null, historicManagementFeePayType?: string | null, autoTrade?: boolean | null } };

export type CheckoutDotComCardPaymentMutationVariables = Exact<{
  args: CardPaymentInput;
}>;


export type CheckoutDotComCardPaymentMutation = { __typename?: 'Mutation', createCardPayment: { __typename?: 'CardPaymentResponse', id?: string | null, status: string, errorMessage?: string | null, redirectUrl?: string | null } };

export type LoginMutationVariables = Exact<{
  loginRequestInput: AuthLoginRequestInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', portalAuthLogin: { __typename?: 'AuthLoginResponse', accessToken?: string | null, refreshToken?: string | null, userToken?: string | null, mfaToken?: string | null } };

export type GetMfaAuthenticatorsMutationVariables = Exact<{
  getMfaAuthenticatorsRequestInput: AuthGetMfaAuthenticatorsRequestInput;
}>;


export type GetMfaAuthenticatorsMutation = { __typename?: 'Mutation', portalAuthMfaAuthenticators: { __typename?: 'AuthGetMfaAuthenticatorsResponse', mfaAuthenticators: Array<{ __typename?: 'AuthMfaAuthenticator', id: string, active: boolean, authenticatorType: string, name: string, oobChannel: string }> } };

export type IssueMfaChallengeMutationVariables = Exact<{
  mfaChallengeRequestInput: AuthMfaChallengeRequestInput;
}>;


export type IssueMfaChallengeMutation = { __typename?: 'Mutation', portalAuthMfaChallenge: { __typename?: 'AuthMfaChallengeResponse', challengeType: string, oobCode: string } };

export type SubmitOneTimePasscodeMutationVariables = Exact<{
  args: AuthMfaOobCodeVerifyRequestInput;
}>;


export type SubmitOneTimePasscodeMutation = { __typename?: 'Mutation', portalAuthMfaVerify: { __typename?: 'AuthMfaOobCodeVerifyResponse', accessToken: string, idToken: string, userToken: string, refreshToken: string, error?: string | null, errorDescription?: string | null } };

export type RefreshAccessTokenMutationVariables = Exact<{
  input: AuthRefreshAccessTokenRequestInput;
}>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', authRefreshAccessToken: { __typename?: 'AuthRefreshAccessTokenResponse', accessToken: string, refreshToken: string, userToken: string } };

export type ResetPasswordMutationMutationVariables = Exact<{
  resetPasswordInput: AuthResetPasswordInput;
}>;


export type ResetPasswordMutationMutation = { __typename?: 'Mutation', portalAuthResetPassword: { __typename?: 'AuthResetPasswordResponse', emailAddress: string } };

export type PortalNotificationsQueryVariables = Exact<{
  from: Scalars['Int'];
  pageSize: Scalars['Int'];
}>;


export type PortalNotificationsQuery = { __typename?: 'Query', portalNotifications: { __typename?: 'NotificationResponse', total: number, pageSize: number, from: number, totalPages: number, unreadCount: number, results: Array<{ __typename?: 'Notification', id: string, category: string, type: string, summary: string, description?: string | null, isRead: boolean, createdDateTime: string, updatedDateTime?: string | null }> } };

export type MarkNotificationsReadMutationVariables = Exact<{
  request: MarkNotificationsReadRequest;
}>;


export type MarkNotificationsReadMutation = { __typename?: 'Mutation', markNotificationsRead: boolean };

export type PortalPortfolioAnnualisedReturnQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['Int']>;
}>;


export type PortalPortfolioAnnualisedReturnQuery = { __typename?: 'Query', portalPortfolioAnnualisedReturn?: { __typename?: 'PortalPortfolioAnnualisedReturn', years?: Array<{ __typename?: 'PortalAnnualisedReturnItem', date: string, value: number }> | null, monthly?: Array<{ __typename?: 'PortalAnnualisedReturnItem', date: string, value: number }> | null } | null };


export const GetMiscellaneousDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMiscellaneous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"miscellaneous"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<GetMiscellaneousQuery, GetMiscellaneousQueryVariables>;
export const GetUserPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalClientPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoginDate"}},{"kind":"Field","name":{"kind":"Name","value":"managementFeePayment"}},{"kind":"Field","name":{"kind":"Name","value":"annualManagementFeePayType"}},{"kind":"Field","name":{"kind":"Name","value":"historicManagementFeePayType"}},{"kind":"Field","name":{"kind":"Name","value":"bankTransferChaseEmailCount"}},{"kind":"Field","name":{"kind":"Name","value":"autoTrade"}}]}}]}}]} as unknown as DocumentNode<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>;
export const AiChatAuthUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AIChatAuthUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]} as unknown as DocumentNode<AiChatAuthUserQuery, AiChatAuthUserQueryVariables>;
export const AuthChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changePasswordInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authChangePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"changePasswordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changePasswordInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wasPasswordChanged"}}]}}]}}]} as unknown as DocumentNode<AuthChangePasswordMutation, AuthChangePasswordMutationVariables>;
export const CreatePaymentSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePaymentSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentSession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPaymentSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentSession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentSession"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSessionSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSessionToken"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentSessionMutation, CreatePaymentSessionMutationVariables>;
export const CreateStripeRecurringPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStripeRecurringPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeRecurringPayment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeRecurringPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStripeRecurringPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stripeRecurringPayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeRecurringPayment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subId"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<CreateStripeRecurringPaymentMutation, CreateStripeRecurringPaymentMutationVariables>;
export const DeletePaymentCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePaymentCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instrumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCardDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"instrumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instrumentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSuccess"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DeletePaymentCardMutation, DeletePaymentCardMutationVariables>;
export const FinalizePaymentSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizePaymentSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"finalizePaymentSession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizePaymentSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizePaymentSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"finalizePaymentSession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"finalizePaymentSession"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"providerPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<FinalizePaymentSessionMutation, FinalizePaymentSessionMutationVariables>;
export const AuthUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<AuthUserQuery, AuthUserQueryVariables>;
export const PaymentReferenceNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paymentReferenceNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentReferenceNumber"}}]}}]} as unknown as DocumentNode<PaymentReferenceNumberQuery, PaymentReferenceNumberQueryVariables>;
export const PaymentGetCardDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentGetCardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGetCardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"expiry"}},{"kind":"Field","name":{"kind":"Name","value":"scheme"}},{"kind":"Field","name":{"kind":"Name","value":"mitConsentedFlag"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMitFlag"}}]}}]}}]} as unknown as DocumentNode<PaymentGetCardDetailsQuery, PaymentGetCardDetailsQueryVariables>;
export const RecurringPaymentPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecurringPaymentPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recurringPaymentPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickName"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"unitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"recurringInterval"}},{"kind":"Field","name":{"kind":"Name","value":"recurringIntervalCount"}}]}}]}}]} as unknown as DocumentNode<RecurringPaymentPricesQuery, RecurringPaymentPricesQueryVariables>;
export const CreateStripePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStripePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripePayment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripePaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStripePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stripePayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripePayment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<CreateStripePaymentMutation, CreateStripePaymentMutationVariables>;
export const UpdateDefaultCheckoutDotComCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDefaultCheckoutDotComCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultMitCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DefaultMitCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDefaultMitCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"defaultMitCard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultMitCard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<UpdateDefaultCheckoutDotComCardMutation, UpdateDefaultCheckoutDotComCardMutationVariables>;
export const PortalUpdatePreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PortalUpdatePreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalUpdatePreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"managementFeePayment"}},{"kind":"Field","name":{"kind":"Name","value":"annualManagementFeePayType"}},{"kind":"Field","name":{"kind":"Name","value":"historicManagementFeePayType"}},{"kind":"Field","name":{"kind":"Name","value":"autoTrade"}}]}}]}}]} as unknown as DocumentNode<PortalUpdatePreferencesMutation, PortalUpdatePreferencesMutationVariables>;
export const CheckoutDotComCardPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutDotComCardPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CardPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCardPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardPayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<CheckoutDotComCardPaymentMutation, CheckoutDotComCardPaymentMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthLoginRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalAuthLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loginRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}},{"kind":"Field","name":{"kind":"Name","value":"mfaToken"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const GetMfaAuthenticatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetMFAAuthenticators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getMfaAuthenticatorsRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthGetMfaAuthenticatorsRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalAuthMfaAuthenticators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"getMfaAuthenticatorsRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getMfaAuthenticatorsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfaAuthenticators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"authenticatorType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oobChannel"}}]}}]}}]}}]} as unknown as DocumentNode<GetMfaAuthenticatorsMutation, GetMfaAuthenticatorsMutationVariables>;
export const IssueMfaChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssueMFAChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mfaChallengeRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthMfaChallengeRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalAuthMfaChallenge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mfaChallengeRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mfaChallengeRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeType"}},{"kind":"Field","name":{"kind":"Name","value":"oobCode"}}]}}]}}]} as unknown as DocumentNode<IssueMfaChallengeMutation, IssueMfaChallengeMutationVariables>;
export const SubmitOneTimePasscodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitOneTimePasscode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthMfaOobCodeVerifyRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalAuthMfaVerify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mfaOobCodeVerifyRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"errorDescription"}}]}}]}}]} as unknown as DocumentNode<SubmitOneTimePasscodeMutation, SubmitOneTimePasscodeMutationVariables>;
export const RefreshAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthRefreshAccessTokenRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authRefreshAccessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshAccessTokenRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}}]}}]}}]} as unknown as DocumentNode<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;
export const ResetPasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resetPasswordInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalAuthResetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resetPasswordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resetPasswordInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>;
export const PortalNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortalNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"unreadCount"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDateTime"}}]}}]}}]}}]} as unknown as DocumentNode<PortalNotificationsQuery, PortalNotificationsQueryVariables>;
export const MarkNotificationsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkNotificationsReadRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}]}]}}]} as unknown as DocumentNode<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;
export const PortalPortfolioAnnualisedReturnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortalPortfolioAnnualisedReturn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portfolioId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalPortfolioAnnualisedReturn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portfolioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portfolioId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthly"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<PortalPortfolioAnnualisedReturnQuery, PortalPortfolioAnnualisedReturnQueryVariables>;